const processing_activities_messages = {
  page_title: ['processing_activities>>page_title', 'Processing activities'],
  page_subtitle: ['processing_activities>>page_subtitle', 'Record of processing activities'],
  page_help: [
    'processing_activities>>page_help',
    'View published processing activities, linked assets, review progress, DPIA indications and review priority.',
  ],
  draft_badge: ['processing_activities>>draft_badge', 'Draft'],
  review_placeholder: ['processing_activities>>review_placeholder', '—'],
  forbidden_title: ['processing_activities>>forbidden_title', 'Access denied'],
  forbidden_body: [
    'processing_activities>>forbidden_body',
    'You do not have permission to view processing activities for this organization.',
  ],
  forbidden_back: ['processing_activities>>forbidden_back', 'Back to home'],
  error_state: [
    'processing_activities>>error_state',
    'The processing activities could not be loaded. Try again. If the problem continues, contact support and provide the reference shown.',
  ],
  help: {
    title: ['processing_activities>>help>>title', 'Processing activities'],
    body: [
      'processing_activities>>help>>body',
      'This register shows published processing activities for your organization, including linked assets, review responses, DPIA indications and review priority.',
    ],
  },
  mock_preview: {
    legend: ['processing_activities>>mock_preview>>legend', 'Preview — not connected to backend'],
    tooltip: ['processing_activities>>mock_preview>>tooltip', 'Preview — not connected to backend'],
    aria_label: ['processing_activities>>mock_preview>>aria_label', 'Preview data'],
    action_toast: ['processing_activities>>mock_preview>>action_toast', 'This action is not connected to the backend yet.'],
    detail_toast: ['processing_activities>>mock_preview>>detail_toast', 'Activity detail view is not connected to the backend yet.'],
    create_toast: ['processing_activities>>mock_preview>>create_toast', 'Create processing activity is not available yet.'],
    create_saved_toast: [
      'processing_activities>>mock_preview>>create_saved_toast',
      'Save is preview only — not connected to the backend yet.',
    ],
    open_lia_toast: ['processing_activities>>mock_preview>>open_lia_toast', 'LIA workflow is not connected to the backend yet.'],
    archive_toast: ['processing_activities>>mock_preview>>archive_toast', 'Archive is not connected to the backend yet.'],
    lia_saved_toast: [
      'processing_activities>>mock_preview>>lia_saved_toast',
      'LIA save is preview only — not connected to the backend yet.',
    ],
    lia_submit_toast: [
      'processing_activities>>mock_preview>>lia_submit_toast',
      'LIA submit is preview only — not connected to the backend yet.',
    ],
    lia_approve_toast: [
      'processing_activities>>mock_preview>>lia_approve_toast',
      'LIA approve is preview only — not connected to the backend yet.',
    ],
  },
  archive_confirm: {
    title: ['processing_activities>>archive_confirm>>title', 'Archive processing activity'],
    body: ['processing_activities>>archive_confirm>>body', 'Archive "{{name}}"? Archived activities remain visible in the archived view.'],
    success: ['processing_activities>>archive_confirm>>success', 'Processing activity archived.'],
    error: ['processing_activities>>archive_confirm>>error', 'Could not archive the processing activity. Try again.'],
    already_archived: ['processing_activities>>archive_confirm>>already_archived', 'This processing activity is already archived.'],
    never_published: [
      'processing_activities>>archive_confirm>>never_published',
      'Never-published processing activities cannot be archived. Save or publish the draft instead.',
    ],
    active_review: [
      'processing_activities>>archive_confirm>>active_review',
      'This processing activity cannot be archived while it is part of an active ROPA review.',
    ],
    forbidden: ['processing_activities>>archive_confirm>>forbidden', 'You do not have permission to archive this processing activity.'],
  },
  actions: {
    create: ['processing_activities>>actions>>create', 'Create processing activity'],
    open: ['processing_activities>>actions>>open', 'Open'],
    edit_draft: ['processing_activities>>actions>>edit_draft', 'Edit draft'],
    archive: ['processing_activities>>actions>>archive', 'Archive'],
  },
  metrics: {
    published: ['processing_activities>>metrics>>published', 'Published processing activities'],
    archived: ['processing_activities>>metrics>>archived', 'Archived processing activities'],
    drafts_in_progress: ['processing_activities>>metrics>>drafts_in_progress', 'Drafts in progress'],
    assets_awaiting_review: ['processing_activities>>metrics>>assets_awaiting_review', 'Assets awaiting review'],
    assets_awaiting_review_hint: ['processing_activities>>metrics>>assets_awaiting_review_hint', 'Unique assets in an active review'],
    dpia_indications: ['processing_activities>>metrics>>dpia_indications', 'DPIA indications'],
    dpia_indications_hint: ['processing_activities>>metrics>>dpia_indications_hint', 'Flagged asset processing activities'],
  },
  filters: {
    search_placeholder: ['processing_activities>>filters>>search_placeholder', 'Search processing activities'],
    option_all: ['processing_activities>>filters>>option_all', '{{label}}: All'],
    status_label: ['processing_activities>>filters>>status_label', 'Status'],
    status_published: ['processing_activities>>filters>>status_published', 'Status: Published'],
    status_all: ['processing_activities>>filters>>status_all', 'Status: All'],
    status_archived: ['processing_activities>>filters>>status_archived', 'Status: Archived'],
    processing_role_label: ['processing_activities>>filters>>processing_role_label', 'Processing role'],
    processing_role_all: ['processing_activities>>filters>>processing_role_all', 'Processing role: All'],
    review_priority_label: ['processing_activities>>filters>>review_priority_label', 'Review priority'],
    review_priority_all: ['processing_activities>>filters>>review_priority_all', 'Review priority: All'],
    legal_basis_label: ['processing_activities>>filters>>legal_basis_label', 'Legal basis'],
    legal_basis_all: ['processing_activities>>filters>>legal_basis_all', 'Legal basis: All'],
    lia_status_label: ['processing_activities>>filters>>lia_status_label', 'LIA'],
    lia_status_options: {
      missing: ['processing_activities>>filters>>lia_status_options>>missing', 'LIA missing'],
      implemented: ['processing_activities>>filters>>lia_status_options>>implemented', 'LIA implemented'],
      not_lia: ['processing_activities>>filters>>lia_status_options>>not_lia', 'Not LIA'],
    },
    lia_status_missing_tooltip: [
      'processing_activities>>filters>>lia_status_missing_tooltip',
      'At least one Article 6(1)(f) purpose lacks an active valid LIA',
    ],
    lia_status_implemented_tooltip: [
      'processing_activities>>filters>>lia_status_implemented_tooltip',
      'Activities with legitimate interests where every 6(1)(f) purpose has an active valid LIA',
    ],
    draft_status_label: ['processing_activities>>filters>>draft_status_label', 'Draft status'],
    dpia_indication_label: ['processing_activities>>filters>>dpia_indication_label', 'DPIA indication'],
    dpia_indication_yes_tooltip: ['processing_activities>>filters>>dpia_indication_yes_tooltip', 'At least one asset contains DPIA'],
    review_status_label: ['processing_activities>>filters>>review_status_label', 'Review status'],
    more_filters: ['processing_activities>>filters>>more_filters', 'More filters'],
    more_filters_title: ['processing_activities>>filters>>more_filters_title', 'More filters'],
    clear_more_filters: ['processing_activities>>filters>>clear_more_filters', 'Clear filters'],
    apply: ['processing_activities>>filters>>apply', 'Apply'],
    boolean_options: {
      true: ['processing_activities>>filters>>boolean_options>>true', 'Yes'],
      false: ['processing_activities>>filters>>boolean_options>>false', 'No'],
    },
  },
  lia_status: {
    draft: ['processing_activities>>lia_status>>draft', 'Draft'],
  },
  processing_role: {
    controller: ['processing_activities>>processing_role>>controller', 'Controller'],
    processor: ['processing_activities>>processing_role>>processor', 'Processor'],
    joint_controller: ['processing_activities>>processing_role>>joint_controller', 'Joint controller'],
  },
  status: {
    published: ['processing_activities>>status>>published', 'Published'],
    archived: ['processing_activities>>status>>archived', 'Archived'],
    draft: ['processing_activities>>status>>draft', 'Draft'],
  },
  review_priority: {
    normal: ['processing_activities>>review_priority>>normal', 'Normal'],
    elevated: ['processing_activities>>review_priority>>elevated', 'Elevated'],
    high: ['processing_activities>>review_priority>>high', 'High'],
  },
  review_priority_reasons: {
    dpia_indication: ['processing_activities>>review_priority_reasons>>dpia_indication', 'DPIA indication'],
    special_categories: ['processing_activities>>review_priority_reasons>>special_categories', 'Special categories of personal data'],
    processing_outside_eu_eea: [
      'processing_activities>>review_priority_reasons>>processing_outside_eu_eea',
      'Processing outside the EU/EEA',
    ],
    sensitive_personal_data: [
      'processing_activities>>review_priority_reasons>>sensitive_personal_data',
      'Asset marked as processing sensitive personal data',
    ],
    retention_deviation: ['processing_activities>>review_priority_reasons>>retention_deviation', 'Retention deviation'],
    security_measure_deviation: [
      'processing_activities>>review_priority_reasons>>security_measure_deviation',
      'Security measure deviation',
    ],
  },
  legal_basis: {
    gdpr_6_1_a: ['processing_activities>>legal_basis>>gdpr_6_1_a', 'Consent'],
    gdpr_6_1_b: ['processing_activities>>legal_basis>>gdpr_6_1_b', 'Contract'],
    gdpr_6_1_c: ['processing_activities>>legal_basis>>gdpr_6_1_c', 'Legal obligation'],
    gdpr_6_1_d: ['processing_activities>>legal_basis>>gdpr_6_1_d', 'Vital interests'],
    gdpr_6_1_e: ['processing_activities>>legal_basis>>gdpr_6_1_e', 'Public task'],
    gdpr_6_1_f: ['processing_activities>>legal_basis>>gdpr_6_1_f', 'Legitimate interests'],
    consent: ['processing_activities>>legal_basis>>consent', 'Consent'],
    contract: ['processing_activities>>legal_basis>>contract', 'Contract'],
    legal_obligation: ['processing_activities>>legal_basis>>legal_obligation', 'Legal obligation'],
    vital_interests: ['processing_activities>>legal_basis>>vital_interests', 'Vital interests'],
    public_task: ['processing_activities>>legal_basis>>public_task', 'Public task'],
    legitimate_interests: ['processing_activities>>legal_basis>>legitimate_interests', 'Legitimate interests'],
  },
  table: {
    aria_label: ['processing_activities>>table>>aria_label', 'Processing activities register'],
    name: ['processing_activities>>table>>name', 'Name'],
    processing_role: ['processing_activities>>table>>processing_role', 'Processing role'],
    legal_basis: ['processing_activities>>table>>legal_basis', 'Legal basis'],
    current_version: ['processing_activities>>table>>current_version', 'Current version'],
    review_responses: ['processing_activities>>table>>review_responses', 'Review responses'],
    linked_assets: ['processing_activities>>table>>linked_assets', 'Linked assets'],
    dpia_indications: ['processing_activities>>table>>dpia_indications', 'DPIA indications'],
    review_priority: ['processing_activities>>table>>review_priority', 'Review priority'],
    status: ['processing_activities>>table>>status', 'Status'],
    updated: ['processing_activities>>table>>updated', 'Updated'],
    actions: ['processing_activities>>table>>actions', 'Actions'],
    version_label: ['processing_activities>>table>>version_label', 'v{{number}}'],
    review_format: ['processing_activities>>table>>review_format', '{{answered}} / {{included}}'],
    legal_basis_overflow: ['processing_activities>>table>>legal_basis_overflow', '+{{count}} more'],
    row_aria_label: ['processing_activities>>table>>row_aria_label', 'Open processing activity {{name}}'],
  },
  search_status: {
    loading: ['processing_activities>>search_status>>loading', 'Loading processing activities'],
    results_count: ['processing_activities>>search_status>>results_count', '{{count}} processing activities found'],
  },
  empty_state: {
    title: ['processing_activities>>empty_state>>title', 'No processing activities have been created yet.'],
    description: [
      'processing_activities>>empty_state>>description',
      'Create the first processing activity to start building the register.',
    ],
    archived_title: ['processing_activities>>empty_state>>archived_title', 'No archived processing activities found'],
    archived_description: [
      'processing_activities>>empty_state>>archived_description',
      'There are no archived processing activities in this organization yet.',
    ],
    filtered_title: ['processing_activities>>empty_state>>filtered_title', 'No processing activities match the current filters'],
    filtered_description: ['processing_activities>>empty_state>>filtered_description', 'Try adjusting your search or filters.'],
  },
  create_form: {
    dialog_title: ['processing_activities>>create_form>>dialog_title', 'Processing activity'],
    edit_dialog_title: ['processing_activities>>create_form>>edit_dialog_title', 'Processing activity'],
    dialog_subtitle: ['processing_activities>>create_form>>dialog_subtitle', 'Create or update one policy-level processing activity.'],
    draft_subtitle: ['processing_activities>>create_form>>draft_subtitle', 'Edit the draft version of this processing activity.'],
    new_activity_title: ['processing_activities>>create_form>>new_activity_title', 'New processing activity'],
    lia_required_chip: ['processing_activities>>create_form>>lia_required_chip', 'LIA required'],
    open_lia: ['processing_activities>>create_form>>open_lia', 'Open LIA'],
    archive: ['processing_activities>>create_form>>archive', 'Archive activity'],
    sections: {
      basic_information: ['processing_activities>>create_form>>sections>>basic_information', '1. Basic information'],
      legal_and_scope: ['processing_activities>>create_form>>sections>>legal_and_scope', '2. Legal and scope'],
      retention: ['processing_activities>>create_form>>sections>>retention', '3. Retention'],
      security_measures: ['processing_activities>>create_form>>sections>>security_measures', '4. Minimum security measures'],
      admin_comment: ['processing_activities>>create_form>>sections>>admin_comment', '5. Administrator comment'],
    },
    fields: {
      name: ['processing_activities>>create_form>>fields>>name', 'Activity name'],
      legal_basis: ['processing_activities>>create_form>>fields>>legal_basis', 'Legal basis'],
      description: ['processing_activities>>create_form>>fields>>description', 'Activity description'],
      data_subjects: ['processing_activities>>create_form>>fields>>data_subjects', 'Data subject categories'],
      personal_data_categories: ['processing_activities>>create_form>>fields>>personal_data_categories', 'Personal data categories'],
      recipient_categories: ['processing_activities>>create_form>>fields>>recipient_categories', 'Recipient categories'],
      retention_trigger: ['processing_activities>>create_form>>fields>>retention_trigger', 'Retention start trigger'],
      retention_months: ['processing_activities>>create_form>>fields>>retention_months', 'Retention period after trigger (months)'],
      retention_description: ['processing_activities>>create_form>>fields>>retention_description', 'Retention description'],
      admin_comment: ['processing_activities>>create_form>>fields>>admin_comment', 'Administrator comment'],
    },
    data_subjects: {
      customer: ['processing_activities>>create_form>>data_subjects>>customer', 'Customer'],
      user: ['processing_activities>>create_form>>data_subjects>>user', 'User'],
      supplier_contact: ['processing_activities>>create_form>>data_subjects>>supplier_contact', 'Supplier contact'],
      applicant: ['processing_activities>>create_form>>data_subjects>>applicant', 'Applicant'],
      other: ['processing_activities>>create_form>>data_subjects>>other', 'Other'],
    },
    personal_data_categories: {
      contact: ['processing_activities>>create_form>>personal_data_categories>>contact', 'Contact data'],
      usage: ['processing_activities>>create_form>>personal_data_categories>>usage', 'Usage data'],
      identification: ['processing_activities>>create_form>>personal_data_categories>>identification', 'Identification data'],
      communication: ['processing_activities>>create_form>>personal_data_categories>>communication', 'Communication data'],
      other: ['processing_activities>>create_form>>personal_data_categories>>other', 'Other'],
    },
    recipient_categories: {
      internal_functions: ['processing_activities>>create_form>>recipient_categories>>internal_functions', 'Internal functions'],
      processors: ['processing_activities>>create_form>>recipient_categories>>processors', 'Processors'],
      authorities: ['processing_activities>>create_form>>recipient_categories>>authorities', 'Authorities'],
      third_party_suppliers: ['processing_activities>>create_form>>recipient_categories>>third_party_suppliers', 'Third-party suppliers'],
      other: ['processing_activities>>create_form>>recipient_categories>>other', 'Other'],
    },
    retention_triggers: {
      created_at: ['processing_activities>>create_form>>retention_triggers>>created_at', 'Created at'],
      event_based: ['processing_activities>>create_form>>retention_triggers>>event_based', 'Event based'],
      last_activity: ['processing_activities>>create_form>>retention_triggers>>last_activity', 'Last activity'],
      legal_obligation: ['processing_activities>>create_form>>retention_triggers>>legal_obligation', 'Legal obligation'],
      customer_lifecycle: ['processing_activities>>create_form>>retention_triggers>>customer_lifecycle', 'Customer lifecycle'],
    },
    security_measures: {
      access_control: ['processing_activities>>create_form>>security_measures>>access_control', 'Access control'],
      role_based_access: ['processing_activities>>create_form>>security_measures>>role_based_access', 'Role-based access'],
      encryption_in_transit: ['processing_activities>>create_form>>security_measures>>encryption_in_transit', 'Encryption in transit'],
      deletion_routines: ['processing_activities>>create_form>>security_measures>>deletion_routines', 'Deletion routines'],
      vendor_review: ['processing_activities>>create_form>>security_measures>>vendor_review', 'Vendor review'],
      multi_factor_authentication: [
        'processing_activities>>create_form>>security_measures>>multi_factor_authentication',
        'Multi-factor authentication',
      ],
    },
  },
  lia_form: {
    dialog_title: ['processing_activities>>lia_form>>dialog_title', 'Processing activity LIA'],
    dialog_subtitle: [
      'processing_activities>>lia_form>>dialog_subtitle',
      'Legitimate interest assessment linked to one policy-level processing activity.',
    ],
    submit: ['processing_activities>>lia_form>>submit', 'Submit'],
    approve: ['processing_activities>>lia_form>>approve', 'Approve'],
    sections: {
      status_and_description: ['processing_activities>>lia_form>>sections>>status_and_description', '1. LIA status and description'],
      assessments: ['processing_activities>>lia_form>>sections>>assessments', '2. Assessments'],
      safeguards: ['processing_activities>>lia_form>>sections>>safeguards', '3. Safeguards'],
      admin_comment: ['processing_activities>>lia_form>>sections>>admin_comment', '4. Administrator comment'],
    },
    fields: {
      status: ['processing_activities>>lia_form>>fields>>status', 'Status'],
      conclusion: ['processing_activities>>lia_form>>fields>>conclusion', 'Conclusion'],
      legitimate_interest_description: [
        'processing_activities>>lia_form>>fields>>legitimate_interest_description',
        'Legitimate interest description',
      ],
      necessity_assessment: ['processing_activities>>lia_form>>fields>>necessity_assessment', 'Necessity assessment'],
      balancing_assessment: ['processing_activities>>lia_form>>fields>>balancing_assessment', 'Balancing assessment'],
      impact_on_data_subjects: ['processing_activities>>lia_form>>fields>>impact_on_data_subjects', 'Impact on data subjects'],
      admin_comment: ['processing_activities>>lia_form>>fields>>admin_comment', 'Administrator comment'],
    },
    status_options: {
      draft: ['processing_activities>>lia_form>>status_options>>draft', 'Draft'],
      submitted: ['processing_activities>>lia_form>>status_options>>submitted', 'Submitted'],
      approved: ['processing_activities>>lia_form>>status_options>>approved', 'Approved'],
      rejected: ['processing_activities>>lia_form>>status_options>>rejected', 'Rejected'],
      archived: ['processing_activities>>lia_form>>status_options>>archived', 'Archived'],
    },
    conclusion_options: {
      approved: ['processing_activities>>lia_form>>conclusion_options>>approved', 'Approved'],
      not_approved: ['processing_activities>>lia_form>>conclusion_options>>not_approved', 'Not approved'],
      approved_with_conditions: [
        'processing_activities>>lia_form>>conclusion_options>>approved_with_conditions',
        'Approved with conditions',
      ],
    },
    safeguards: {
      transparency: ['processing_activities>>lia_form>>safeguards>>transparency', 'Transparency'],
      opt_out: ['processing_activities>>lia_form>>safeguards>>opt_out', 'Opt-out'],
      data_minimization: ['processing_activities>>lia_form>>safeguards>>data_minimization', 'Data minimization'],
      limited_retention: ['processing_activities>>lia_form>>safeguards>>limited_retention', 'Limited retention'],
      pseudonymization: ['processing_activities>>lia_form>>safeguards>>pseudonymization', 'Pseudonymization'],
      human_review: ['processing_activities>>lia_form>>safeguards>>human_review', 'Human review'],
    },
  },
  purpose_lia: {
    page_title: ['processing_activities>>purpose_lia>>page_title', 'Legitimate interest assessment'],
    page_subtitle: ['processing_activities>>purpose_lia>>page_subtitle', 'Linked to the purpose "{{purpose}}"'],
    close: ['processing_activities>>purpose_lia>>close', 'Close'],
    save: ['processing_activities>>purpose_lia>>save', 'Save LIA'],
    status: ['processing_activities>>purpose_lia>>status', 'Validation status'],
    revision: ['processing_activities>>purpose_lia>>revision', 'Revision'],
    responsible: ['processing_activities>>purpose_lia>>responsible', 'Responsible'],
    assessment_date: ['processing_activities>>purpose_lia>>assessment_date', 'Assessment date'],
    next_review_date: ['processing_activities>>purpose_lia>>next_review_date', 'Next review date'],
    truth_note: [
      'processing_activities>>purpose_lia>>truth_note',
      'This LIA documents the organisation’s current legitimate-interest assessment for one processing purpose. It is not linked to an asset processing activity and it is not a workflow with submission or approval states.',
    ],
    side_panel: {
      eyebrow: ['processing_activities>>purpose_lia>>side_panel>>eyebrow', 'Read-only context'],
      title: ['processing_activities>>purpose_lia>>side_panel>>title', 'Purpose details'],
      purpose_context: ['processing_activities>>purpose_lia>>side_panel>>purpose_context', 'Purpose context'],
      purpose: ['processing_activities>>purpose_lia>>side_panel>>purpose', 'Purpose'],
      legal_basis: ['processing_activities>>purpose_lia>>side_panel>>legal_basis', 'Legal basis'],
      purpose_comment: ['processing_activities>>purpose_lia>>side_panel>>purpose_comment', 'Purpose comment'],
      retention_rule: ['processing_activities>>purpose_lia>>side_panel>>retention_rule', 'Retention rule'],
      processing_activity: ['processing_activities>>purpose_lia>>side_panel>>processing_activity', 'Processing activity'],
      processing_activity_status: [
        'processing_activities>>purpose_lia>>side_panel>>processing_activity_status',
        'Processing activity status',
      ],
      validation_rules: ['processing_activities>>purpose_lia>>side_panel>>validation_rules', 'Validation rule'],
      validation_rule_1: [
        'processing_activities>>purpose_lia>>side_panel>>validation_rule_1',
        'A published processing activity may not contain an active Article 6(1)(f) purpose without a complete and valid LIA.',
      ],
      validation_rule_2: [
        'processing_activities>>purpose_lia>>side_panel>>validation_rule_2',
        'The legal basis is never changed automatically.',
      ],
      validation_rule_3: [
        'processing_activities>>purpose_lia>>side_panel>>validation_rule_3',
        'If the conclusion does not support legitimate interest, the purpose remains but is invalid for publication.',
      ],
      soft_delete_note: [
        'processing_activities>>purpose_lia>>side_panel>>soft_delete_note',
        'Soft deletion removes the LIA from active validation but preserves it for traceability. A new active LIA may later be created for the same purpose.',
      ],
    },
    sections: {
      legitimate_interest: {
        title: ['processing_activities>>purpose_lia>>sections>>legitimate_interest>>title', 'Legitimate interest'],
        description: ['processing_activities>>purpose_lia>>sections>>legitimate_interest>>description', 'Legitimate interest description'],
        necessity: ['processing_activities>>purpose_lia>>sections>>legitimate_interest>>necessity', 'Necessity assessment'],
      },
      impact: {
        title: ['processing_activities>>purpose_lia>>sections>>impact>>title', 'Impact and balancing assessment'],
        data_subject_impact: ['processing_activities>>purpose_lia>>sections>>impact>>data_subject_impact', 'Impact on data subjects'],
        reasonable_expectations: [
          'processing_activities>>purpose_lia>>sections>>impact>>reasonable_expectations',
          'Reasonable expectations of data subjects',
        ],
        balancing: ['processing_activities>>purpose_lia>>sections>>impact>>balancing', 'Balancing assessment'],
        vulnerable_involved: [
          'processing_activities>>purpose_lia>>sections>>impact>>vulnerable_involved',
          'Vulnerable data subjects involved',
        ],
        vulnerable_yes: ['processing_activities>>purpose_lia>>sections>>impact>>vulnerable_yes', 'Yes'],
        vulnerable_no: ['processing_activities>>purpose_lia>>sections>>impact>>vulnerable_no', 'No'],
        vulnerable_comment: [
          'processing_activities>>purpose_lia>>sections>>impact>>vulnerable_comment',
          'Vulnerable data subjects comment',
        ],
        vulnerable_comment_help: [
          'processing_activities>>purpose_lia>>sections>>impact>>vulnerable_comment_help',
          'Required when vulnerable data subjects are involved.',
        ],
        vulnerable_comment_placeholder: [
          'processing_activities>>purpose_lia>>sections>>impact>>vulnerable_comment_placeholder',
          'Required when vulnerable data subjects are involved.',
        ],
      },
      safeguards: {
        title: ['processing_activities>>purpose_lia>>sections>>safeguards>>title', 'Safeguards'],
        description: ['processing_activities>>purpose_lia>>sections>>safeguards>>description', 'Safeguards description'],
        right_to_object: ['processing_activities>>purpose_lia>>sections>>safeguards>>right_to_object', 'Handling of the right to object'],
      },
      conclusion: {
        title: ['processing_activities>>purpose_lia>>sections>>conclusion>>title', 'Conclusion and administration'],
        conclusion: ['processing_activities>>purpose_lia>>sections>>conclusion>>conclusion', 'Conclusion'],
        comment: ['processing_activities>>purpose_lia>>sections>>conclusion>>comment', 'Conclusion comment'],
      },
    },
    safeguards: {
      transparency: ['processing_activities>>purpose_lia>>safeguards>>transparency', 'Transparency'],
      right_to_object_or_opt_out: [
        'processing_activities>>purpose_lia>>safeguards>>right_to_object_or_opt_out',
        'Right to object or opt out',
      ],
      data_minimisation: ['processing_activities>>purpose_lia>>safeguards>>data_minimisation', 'Data minimisation'],
      limited_retention: ['processing_activities>>purpose_lia>>safeguards>>limited_retention', 'Limited retention'],
      access_restriction: ['processing_activities>>purpose_lia>>safeguards>>access_restriction', 'Access restriction'],
      pseudonymisation: ['processing_activities>>purpose_lia>>safeguards>>pseudonymisation', 'Pseudonymisation'],
      human_review: ['processing_activities>>purpose_lia>>safeguards>>human_review', 'Human review'],
      other: ['processing_activities>>purpose_lia>>safeguards>>other', 'Other safeguard'],
    },
    safeguard_help: {
      transparency: ['processing_activities>>purpose_lia>>safeguard_help>>transparency', 'Clear information about the processing.'],
      right_to_object_or_opt_out: [
        'processing_activities>>purpose_lia>>safeguard_help>>right_to_object_or_opt_out',
        'Simple and effective way to stop the processing.',
      ],
      data_minimisation: [
        'processing_activities>>purpose_lia>>safeguard_help>>data_minimisation',
        'Only necessary contact and relationship data is used.',
      ],
      limited_retention: [
        'processing_activities>>purpose_lia>>safeguard_help>>limited_retention',
        'Data is not retained longer than necessary.',
      ],
      access_restriction: [
        'processing_activities>>purpose_lia>>safeguard_help>>access_restriction',
        'Only authorised users may access the data.',
      ],
      pseudonymisation: [
        'processing_activities>>purpose_lia>>safeguard_help>>pseudonymisation',
        'Direct identifiers are reduced where appropriate.',
      ],
      human_review: [
        'processing_activities>>purpose_lia>>safeguard_help>>human_review',
        'Relevant automated or profiling decisions receive human oversight.',
      ],
      other: ['processing_activities>>purpose_lia>>safeguard_help>>other', 'Describe additional safeguards below.'],
    },
    conclusions: {
      legitimate_interest_supported: [
        'processing_activities>>purpose_lia>>conclusions>>legitimate_interest_supported',
        'Legitimate interest is supported',
      ],
      legitimate_interest_supported_with_safeguards: [
        'processing_activities>>purpose_lia>>conclusions>>legitimate_interest_supported_with_safeguards',
        'Supported subject to safeguards',
      ],
      legitimate_interest_not_supported: [
        'processing_activities>>purpose_lia>>conclusions>>legitimate_interest_not_supported',
        'Legitimate interest is not supported',
      ],
    },
    validation_status: {
      title: ['processing_activities>>purpose_lia>>validation_status>>title', 'Calculated validation status: {{status}}'],
      valid: ['processing_activities>>purpose_lia>>validation_status>>valid', 'Valid LIA'],
      invalid: ['processing_activities>>purpose_lia>>validation_status>>invalid', 'Invalid LIA'],
      valid_body: [
        'processing_activities>>purpose_lia>>validation_status>>valid_body',
        'All required fields are complete and the conclusion supports legitimate interest. This purpose may be included when the processing activity is published.',
      ],
      invalid_body: [
        'processing_activities>>purpose_lia>>validation_status>>invalid_body',
        'Required information is missing or the conclusion does not support legitimate interest. Publication will be blocked for this purpose.',
      ],
    },
    completeness: {
      title: ['processing_activities>>purpose_lia>>completeness>>title', 'Missing required information'],
      legitimate_interest_description: [
        'processing_activities>>purpose_lia>>completeness>>legitimate_interest_description',
        'Legitimate interest description',
      ],
      necessity_assessment: ['processing_activities>>purpose_lia>>completeness>>necessity_assessment', 'Necessity assessment'],
      data_subject_impact: ['processing_activities>>purpose_lia>>completeness>>data_subject_impact', 'Impact on data subjects'],
      reasonable_expectations_assessment: [
        'processing_activities>>purpose_lia>>completeness>>reasonable_expectations_assessment',
        'Reasonable expectations assessment',
      ],
      balancing_assessment: ['processing_activities>>purpose_lia>>completeness>>balancing_assessment', 'Balancing assessment'],
      safeguards_description: ['processing_activities>>purpose_lia>>completeness>>safeguards_description', 'Safeguards description'],
      right_to_object_handling: ['processing_activities>>purpose_lia>>completeness>>right_to_object_handling', 'Right-to-object handling'],
      conclusion: ['processing_activities>>purpose_lia>>completeness>>conclusion', 'Conclusion'],
      conclusion_comment: ['processing_activities>>purpose_lia>>completeness>>conclusion_comment', 'Conclusion comment'],
      responsible_membership: ['processing_activities>>purpose_lia>>completeness>>responsible_membership', 'Responsible person'],
      assessment_date: ['processing_activities>>purpose_lia>>completeness>>assessment_date', 'Assessment date'],
      vulnerable_data_subjects_comment: [
        'processing_activities>>purpose_lia>>completeness>>vulnerable_data_subjects_comment',
        'Vulnerable data subjects comment',
      ],
    },
    soft_delete: {
      action: ['processing_activities>>purpose_lia>>soft_delete>>action', 'Soft delete LIA'],
      title: ['processing_activities>>purpose_lia>>soft_delete>>title', 'Soft delete LIA'],
      reason: ['processing_activities>>purpose_lia>>soft_delete>>reason', 'Deletion reason'],
      help: ['processing_activities>>purpose_lia>>soft_delete>>help', 'Explain why this LIA is being removed from active validation.'],
      confirm: ['processing_activities>>purpose_lia>>soft_delete>>confirm', 'Soft delete LIA'],
    },
    actions: {
      open: ['processing_activities>>purpose_lia>>actions>>open', 'Open LIA'],
      create: ['processing_activities>>purpose_lia>>actions>>create', 'Create LIA'],
      open_or_create: ['processing_activities>>purpose_lia>>actions>>open_or_create', 'Open / Create LIA'],
    },
    validation: {
      vulnerable_comment: [
        'processing_activities>>purpose_lia>>validation>>vulnerable_comment',
        'Enter a comment about vulnerable data subjects.',
      ],
      save_blocked: [
        'processing_activities>>purpose_lia>>validation>>save_blocked',
        'Complete the highlighted required fields before saving.',
      ],
      purpose_not_saved: [
        'processing_activities>>purpose_lia>>validation>>purpose_not_saved',
        'Save the processing activity before opening the LIA for this purpose.',
      ],
    },
    toasts: {
      saved: ['processing_activities>>purpose_lia>>toasts>>saved', 'LIA saved.'],
      soft_deleted: ['processing_activities>>purpose_lia>>toasts>>soft_deleted', 'LIA soft deleted.'],
    },
  },
  editor: {
    create_title: ['processing_activities>>editor>>create_title', 'Create processing activity'],
    edit_title: ['processing_activities>>editor>>edit_title', 'Edit processing activity'],
    create_subtitle: ['processing_activities>>editor>>create_subtitle', 'Create a new processing activity draft.'],
    edit_subtitle: [
      'processing_activities>>editor>>edit_subtitle',
      'Published version remains available while this draft is being edited.',
    ],
    page_help: [
      'processing_activities>>editor>>page_help',
      'Changes are saved to a draft and take effect only when the draft is published.',
    ],
    form_subtitle: [
      'processing_activities>>editor>>form_subtitle',
      'Changes are saved to a draft and take effect only when the draft is published.',
    ],
    new_activity_title: ['processing_activities>>editor>>new_activity_title', 'New processing activity'],
    published_version: ['processing_activities>>editor>>published_version', 'Published version: v{{number}}'],
    lia_required_title: ['processing_activities>>editor>>lia_required_title', 'LIA required'],
    lia_required_body: [
      'processing_activities>>editor>>lia_required_body',
      'A Legitimate Interests Assessment is required for this purpose.',
    ],
    lia_required_chip: ['processing_activities>>editor>>lia_required_chip', 'LIA required'],
    lia_not_required: ['processing_activities>>editor>>lia_not_required', 'Not required'],
    soft_delete_note: [
      'processing_activities>>editor>>soft_delete_note',
      'Deleted purposes are soft deleted and removed from the active list after the draft is saved.',
    ],
    sections: {
      core_information: ['processing_activities>>editor>>sections>>core_information', 'Core information'],
      categories: ['processing_activities>>editor>>sections>>categories', 'Categories'],
      purposes: ['processing_activities>>editor>>sections>>purposes', 'Purposes'],
      purposes_description: [
        'processing_activities>>editor>>sections>>purposes_description',
        'Each purpose has one legal basis, a legal basis comment and its own retention rule.',
      ],
      security_measures: ['processing_activities>>editor>>sections>>security_measures', 'Minimum security measures'],
    },
    fields: {
      name: ['processing_activities>>editor>>fields>>name', 'Name'],
      processing_role: ['processing_activities>>editor>>fields>>processing_role', 'Processing role'],
      description: ['processing_activities>>editor>>fields>>description', 'Description'],
      data_subject_categories: ['processing_activities>>editor>>fields>>data_subject_categories', 'Categories of data subjects'],
      personal_data_categories: ['processing_activities>>editor>>fields>>personal_data_categories', 'Categories of personal data'],
      recipient_categories: ['processing_activities>>editor>>fields>>recipient_categories', 'Recipient categories'],
      category_placeholder: ['processing_activities>>editor>>fields>>category_placeholder', 'Search or create a category'],
      category_help: ['processing_activities>>editor>>fields>>category_help', 'Press Enter or type a comma to add a category.'],
      purpose: ['processing_activities>>editor>>fields>>purpose', 'Purpose'],
      legal_basis: ['processing_activities>>editor>>fields>>legal_basis', 'Legal basis'],
      legal_basis_placeholder: ['processing_activities>>editor>>fields>>legal_basis_placeholder', 'Select legal basis'],
      legal_basis_comment: ['processing_activities>>editor>>fields>>legal_basis_comment', 'Legal basis comment'],
      legal_basis_comment_placeholder: [
        'processing_activities>>editor>>fields>>legal_basis_comment_placeholder',
        'Explain why the selected legal basis applies',
      ],
      retention_trigger: ['processing_activities>>editor>>fields>>retention_trigger', 'Retention start trigger'],
      retention_value: ['processing_activities>>editor>>fields>>retention_value', 'Retention period'],
      retention_unit: ['processing_activities>>editor>>fields>>retention_unit', 'Retention unit'],
      retention_comment: ['processing_activities>>editor>>fields>>retention_comment', 'Retention comment'],
      minimum_security_measures: ['processing_activities>>editor>>fields>>minimum_security_measures', 'Minimum security measures'],
    },
    retention_units: {
      days: ['processing_activities>>editor>>retention_units>>days', 'Days'],
      months: ['processing_activities>>editor>>retention_units>>months', 'Months'],
      years: ['processing_activities>>editor>>retention_units>>years', 'Years'],
    },
    legal_basis_with_article: {
      gdpr_6_1_a: ['processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_a', 'Consent — Article 6(1)(a)'],
      gdpr_6_1_b: ['processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_b', 'Contract — Article 6(1)(b)'],
      gdpr_6_1_c: ['processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_c', 'Legal obligation — Article 6(1)(c)'],
      gdpr_6_1_d: ['processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_d', 'Vital interests — Article 6(1)(d)'],
      gdpr_6_1_e: [
        'processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_e',
        'Public interest or exercise of official authority — Article 6(1)(e)',
      ],
      gdpr_6_1_f: ['processing_activities>>editor>>legal_basis_with_article>>gdpr_6_1_f', 'Legitimate interests — Article 6(1)(f)'],
    },
    table: {
      purpose: ['processing_activities>>editor>>table>>purpose', 'Purpose'],
      legal_basis: ['processing_activities>>editor>>table>>legal_basis', 'Legal basis'],
      retention_period: ['processing_activities>>editor>>table>>retention_period', 'Retention period'],
      lia: ['processing_activities>>editor>>table>>lia', 'LIA'],
      actions: ['processing_activities>>editor>>table>>actions', 'Actions'],
      open_actions: ['processing_activities>>editor>>table>>open_actions', 'Open purpose actions'],
    },
    actions: {
      close: ['processing_activities>>editor>>actions>>close', 'Close'],
      save_and_continue: ['processing_activities>>editor>>actions>>save_and_continue', 'Save and continue'],
      publish_and_close: ['processing_activities>>editor>>actions>>publish_and_close', 'Publish and close'],
      discard_draft: ['processing_activities>>editor>>actions>>discard_draft', 'Discard draft'],
      create_purpose: ['processing_activities>>editor>>actions>>create_purpose', '+ Create purpose'],
      edit_purpose: ['processing_activities>>editor>>actions>>edit_purpose', 'Edit purpose'],
      delete_purpose: ['processing_activities>>editor>>actions>>delete_purpose', 'Delete purpose'],
      restore_purpose: ['processing_activities>>editor>>actions>>restore_purpose', 'Restore purpose'],
      move_purpose_up: ['processing_activities>>editor>>actions>>move_purpose_up', 'Move up'],
      move_purpose_down: ['processing_activities>>editor>>actions>>move_purpose_down', 'Move down'],
    },
    discard_draft: {
      title: ['processing_activities>>editor>>discard_draft>>title', 'Discard shared draft?'],
      body: [
        'processing_activities>>editor>>discard_draft>>body',
        'This deletes the shared draft for all administrators. Local unsaved changes will also be lost.',
      ],
      success: ['processing_activities>>editor>>discard_draft>>success', 'Draft discarded'],
      error: ['processing_activities>>editor>>discard_draft>>error', 'Could not discard the draft.'],
    },

    purpose_dialog: {
      create_title: ['processing_activities>>editor>>purpose_dialog>>create_title', 'Create purpose'],
      edit_title: ['processing_activities>>editor>>purpose_dialog>>edit_title', 'Edit purpose'],
      subtitle: [
        'processing_activities>>editor>>purpose_dialog>>subtitle',
        'Add one purpose and its legal basis to this processing activity.',
      ],
    },
    publish_dialog: {
      title: ['processing_activities>>editor>>publish_dialog>>title', 'Publish processing activity'],
      change_comment: ['processing_activities>>editor>>publish_dialog>>change_comment', 'Change comment'],
      help: ['processing_activities>>editor>>publish_dialog>>help', 'Describe what changed in this version.'],
    },
    validation: {
      category_required: ['processing_activities>>editor>>validation>>category_required', 'Add at least one category'],
      purpose_required: ['processing_activities>>editor>>validation>>purpose_required', 'Add at least one purpose'],
      purpose_incomplete: [
        'processing_activities>>editor>>validation>>purpose_incomplete',
        'Complete all purpose fields before publishing',
      ],
      legal_basis_comment_required: [
        'processing_activities>>editor>>validation>>legal_basis_comment_required',
        'Legal basis comment is required for legitimate interests',
      ],
      retention_value_negative: [
        'processing_activities>>editor>>validation>>retention_value_negative',
        'Retention period must be at least 1.',
      ],
      retention_value_integer: ['processing_activities>>editor>>validation>>retention_value_integer', 'Enter a whole number of at least 1'],
      purpose_retention_invalid: [
        'processing_activities>>editor>>validation>>purpose_retention_invalid',
        'This purpose has an invalid retention period',
      ],
      purpose_retention_publish: [
        'processing_activities>>editor>>validation>>purpose_retention_publish',
        'Fix retention period for purpose {{number}}',
      ],
      publish_blocked: ['processing_activities>>editor>>validation>>publish_blocked', 'Complete the required fields before publishing.'],
    },
    success: {
      saved: ['processing_activities>>editor>>success>>saved', 'Draft saved'],
      published: ['processing_activities>>editor>>success>>published', 'Processing activity published'],
    },
    errors: {
      load_failed: ['processing_activities>>editor>>errors>>load_failed', 'The processing activity draft could not be loaded.'],
      validation_failed: ['processing_activities>>editor>>errors>>validation_failed', 'Complete the required fields before continuing.'],
      save_failed: ['processing_activities>>editor>>errors>>save_failed', 'The draft could not be saved. Try again.'],
      publish_failed: ['processing_activities>>editor>>errors>>publish_failed', 'Publishing failed. Try again.'],
      draft_conflict: [
        'processing_activities>>editor>>errors>>draft_conflict',
        'This draft was changed by another administrator. Reload and try again.',
      ],
    },
  },

  detail: {
    eyebrow: ['processing_activities>>detail>>eyebrow', 'Processing activity'],
    subtitle: ['processing_activities>>detail>>subtitle', '{{role}} · {{version}} · {{status}}'],
    draft_indicator: ['processing_activities>>detail>>draft_indicator', 'Draft in progress'],
    actions: {
      back: ['processing_activities>>detail>>actions>>back', 'Back'],
      edit: ['processing_activities>>detail>>actions>>edit', 'Edit'],
      open_draft: ['processing_activities>>detail>>actions>>open_draft', 'Open draft'],
    },
    sections: {
      published: ['processing_activities>>detail>>sections>>published', 'Published processing activity'],
      changelog: ['processing_activities>>detail>>sections>>changelog', 'Change log'],
      purposes: ['processing_activities>>detail>>sections>>purposes', 'Purposes'],
      asset_processings: ['processing_activities>>detail>>sections>>asset_processings', 'Asset processing activities'],
    },
    fields: {
      description: ['processing_activities>>detail>>fields>>description', 'Description'],
      processing_role: ['processing_activities>>detail>>fields>>processing_role', 'Processing role'],
      published_version: ['processing_activities>>detail>>fields>>published_version', 'Published version'],
      status: ['processing_activities>>detail>>fields>>status', 'Status'],
      last_published: ['processing_activities>>detail>>fields>>last_published', 'Last published'],
      data_subject_categories: ['processing_activities>>detail>>fields>>data_subject_categories', 'Categories of data subjects'],
      personal_data_categories: ['processing_activities>>detail>>fields>>personal_data_categories', 'Categories of personal data'],
      recipient_categories: ['processing_activities>>detail>>fields>>recipient_categories', 'Recipient categories'],
      minimum_security_measures: ['processing_activities>>detail>>fields>>minimum_security_measures', 'Minimum security measures'],
      purpose: ['processing_activities>>detail>>fields>>purpose', 'Purpose'],
      legal_basis: ['processing_activities>>detail>>fields>>legal_basis', 'Legal basis'],
      legal_basis_comment: ['processing_activities>>detail>>fields>>legal_basis_comment', 'Legal basis comment'],
      lia_required: ['processing_activities>>detail>>fields>>lia_required', 'LIA required'],
      linked_lia: ['processing_activities>>detail>>fields>>linked_lia', 'Linked LIA'],
      linked_lia_not_required: ['processing_activities>>detail>>fields>>linked_lia_not_required', 'Not required for this legal basis'],
      retention_period: ['processing_activities>>detail>>fields>>retention_period', 'Retention period'],
      purpose_status: ['processing_activities>>detail>>fields>>purpose_status', 'Purpose status'],
    },
    purposes: {
      help: ['processing_activities>>detail>>purposes>>help', 'Purpose panels are collapsed by default.'],
      show_removed: ['processing_activities>>detail>>purposes>>show_removed', 'Show removed purposes'],
      removed: ['processing_activities>>detail>>purposes>>removed', 'Removed'],
    },
    changelog: {
      version_label: ['processing_activities>>detail>>changelog>>version_label', 'Version {{number}}'],
      published_meta: ['processing_activities>>detail>>changelog>>published_meta', 'Published {{date}} by {{name}}'],
    },
    metrics: {
      aria_label: ['processing_activities>>detail>>metrics>>aria_label', 'Processing activity metrics'],
      linked_asset_processings: ['processing_activities>>detail>>metrics>>linked_asset_processings', 'Linked asset processing activities'],
      awaiting_response: ['processing_activities>>detail>>metrics>>awaiting_response', 'Awaiting response'],
      submitted: ['processing_activities>>detail>>metrics>>submitted', 'Submitted'],
      accepted: ['processing_activities>>detail>>metrics>>accepted', 'Accepted'],
      dpia_indicated: ['processing_activities>>detail>>metrics>>dpia_indicated', 'DPIA indicated'],
      sensitive_personal_data: ['processing_activities>>detail>>metrics>>sensitive_personal_data', 'Sensitive personal data'],
    },
    asset_processings: {
      help: [
        'processing_activities>>detail>>asset_processings>>help',
        'All linked asset processing activities for this processing activity.',
      ],
      filters_aria_label: ['processing_activities>>detail>>asset_processings>>filters_aria_label', 'Asset processing filters'],
      filters: {
        all: ['processing_activities>>detail>>asset_processings>>filters>>all', 'All'],
        review_status: ['processing_activities>>detail>>asset_processings>>filters>>review_status', 'Official review status'],
        dpia_indication: ['processing_activities>>detail>>asset_processings>>filters>>dpia_indication', 'DPIA indicated'],
        dpia_request: ['processing_activities>>detail>>asset_processings>>filters>>dpia_request', 'DPIA request'],
        dpia_status_lifecycle: ['processing_activities>>detail>>asset_processings>>filters>>dpia_status_lifecycle', 'DPIA status'],
        dpia_status: ['processing_activities>>detail>>asset_processings>>filters>>dpia_status', 'DPIA status'],
        sensitive_personal_data: [
          'processing_activities>>detail>>asset_processings>>filters>>sensitive_personal_data',
          'Sensitive personal data',
        ],
        operational_owner: ['processing_activities>>detail>>asset_processings>>filters>>operational_owner', 'Operational owner'],
        asset_type: ['processing_activities>>detail>>asset_processings>>filters>>asset_type', 'Asset type'],
      },
    },
    official_review_status: {
      not_requested: ['processing_activities>>detail>>official_review_status>>not_requested', 'Not requested'],
      awaiting_response: ['processing_activities>>detail>>official_review_status>>awaiting_response', 'Awaiting response'],
      submitted: ['processing_activities>>detail>>official_review_status>>submitted', 'Submitted'],
      clarification_requested: [
        'processing_activities>>detail>>official_review_status>>clarification_requested',
        'Clarification requested',
      ],
      accepted: ['processing_activities>>detail>>official_review_status>>accepted', 'Accepted'],
    },
    dpia_status: {
      not_indicated: ['processing_activities>>detail>>dpia_status>>not_indicated', 'DPIA not indicated'],
      indicated: ['processing_activities>>detail>>dpia_status>>indicated', 'DPIA indicated'],
      not_required: ['processing_activities>>detail>>dpia_status>>not_required', 'DPIA not required'],
      required: ['processing_activities>>detail>>dpia_status>>required', 'DPIA required'],
      in_progress: ['processing_activities>>detail>>dpia_status>>in_progress', 'In progress'],
      ready_for_review: ['processing_activities>>detail>>dpia_status>>ready_for_review', 'Ready for review'],
      clarification_requested: ['processing_activities>>detail>>dpia_status>>clarification_requested', 'Clarification requested'],
      decision_made: ['processing_activities>>detail>>dpia_status>>decision_made', 'Decision made'],
    },
    table: {
      aria_label: ['processing_activities>>detail>>table>>aria_label', 'Asset processing activities table'],
      asset: ['processing_activities>>detail>>table>>asset', 'Asset'],
      operational_owner: ['processing_activities>>detail>>table>>operational_owner', 'Operational owner'],
      not_assigned: ['processing_activities>>detail>>table>>not_assigned', 'Not assigned'],
      official_review_status: ['processing_activities>>detail>>table>>official_review_status', 'Official review status'],
      last_updated: ['processing_activities>>detail>>table>>last_updated', 'Last updated'],
      dpia_status: ['processing_activities>>detail>>table>>dpia_status', 'DPIA status'],
      active_purposes: ['processing_activities>>detail>>table>>active_purposes', 'Active purposes'],
      sensitive_personal_data: ['processing_activities>>detail>>table>>sensitive_personal_data', 'Sensitive personal data'],
      open_actions: ['processing_activities>>detail>>table>>open_actions', 'Open asset processing activity actions'],
      row_aria_label: ['processing_activities>>detail>>table>>row_aria_label', 'Open asset processing activity for {{name}}'],
    },
    empty_state: {
      no_active_purposes: ['processing_activities>>detail>>empty_state>>no_active_purposes', 'No active purposes are available.'],
      no_asset_processings: [
        'processing_activities>>detail>>empty_state>>no_asset_processings',
        'No asset processing activities are linked to this processing activity.',
      ],
      no_asset_processings_filtered: [
        'processing_activities>>detail>>empty_state>>no_asset_processings_filtered',
        'No asset processing activities match the current filters.',
      ],
      no_changelog: ['processing_activities>>detail>>empty_state>>no_changelog', 'No changelog entries are available.'],
    },
    errors: {
      load_failed: [
        'processing_activities>>detail>>errors>>load_failed',
        'The processing activity could not be loaded. Try again. If the problem continues, contact support and provide the reference shown.',
      ],
      not_found: [
        'processing_activities>>detail>>errors>>not_found',
        'This processing activity could not be found. It may have been removed, or you may not have access.',
      ],
    },
    mock: {
      linked_lia_not_linked: ['processing_activities>>detail>>mock>>linked_lia_not_linked', 'Not yet linked'],
      linked_lia_tooltip: ['processing_activities>>detail>>mock>>linked_lia_tooltip', 'Linked LIA is not connected to the backend yet.'],
      client_side_filters_tooltip: [
        'processing_activities>>detail>>mock>>client_side_filters_tooltip',
        'Filtering is applied in the browser until backend filters are available.',
      ],
      asset_type_filter_tooltip: [
        'processing_activities>>detail>>mock>>asset_type_filter_tooltip',
        'Asset type filter is not connected to the backend yet.',
      ],
    },
  },
  asset_ropa: {
    page_title: ['processing_activities>>ropa_review>>page_title', 'ROPA review'],
    owner_page_title: ['processing_activities>>asset_ropa>>owner_page_title', 'My Asset ROPA'],
    page_subtitle: [
      'processing_activities>>asset_ropa>>page_subtitle',
      'Review asset-specific processing activities during the active organisation ROPA review.',
    ],
    owner_page_subtitle: [
      'processing_activities>>asset_ropa>>owner_page_subtitle',
      'Review and update processing activities for assets you own during the active ROPA review.',
    ],
    page_help: [
      'processing_activities>>asset_ropa>>page_help',
      'Use filters to find assets. Expand an asset to review linked processing activities.',
    ],
    owner_page_help: [
      'processing_activities>>asset_ropa>>owner_page_help',
      'Open or edit each asset processing activity, save your work, and submit completed items for administrator review.',
    ],
    search_status: {
      loading: ['processing_activities>>asset_ropa>>search_status>>loading', 'Loading asset ROPA data'],
      assets_count: ['processing_activities>>asset_ropa>>search_status>>assets_count', '{{count}} assets found'],
      expanded_asset: ['processing_activities>>asset_ropa>>search_status>>expanded_asset', 'Expanded asset {{name}}'],
      owner_assets_count: ['processing_activities>>asset_ropa>>search_status>>owner_assets_count', '{{count}} assets in your workspace'],
    },
    owner_workspace: {
      page_title: ['processing_activities>>asset_ropa>>owner_workspace>>page_title', 'Asset ROPA'],
      page_subtitle: [
        'processing_activities>>asset_ropa>>owner_workspace>>page_subtitle',
        'Maintain the processing activities for assets you own',
      ],
      intro: {
        eyebrow: ['processing_activities>>asset_ropa>>owner_workspace>>intro>>eyebrow', 'Permanent workspace'],
        title: ['processing_activities>>asset_ropa>>owner_workspace>>intro>>title', 'Maintain current Asset ROPA information'],
        body: [
          'processing_activities>>asset_ropa>>owner_workspace>>intro>>body',
          'This page shows GDPR-relevant assets where you are the operational owner. The information is permanent and can be updated at any time, regardless of whether a formal ROPA review is active. There is no submission or review status in this mode.',
        ],
        owner_badge: ['processing_activities>>asset_ropa>>owner_workspace>>intro>>owner_badge', 'Owner view'],
      },
      metrics: {
        aria_label: ['processing_activities>>asset_ropa>>owner_workspace>>metrics>>aria_label', 'Owner Asset ROPA metrics'],
        gdpr_relevant_assets: ['processing_activities>>asset_ropa>>owner_workspace>>metrics>>gdpr_relevant_assets', 'GDPR-relevant assets'],
        without_processing_activities: [
          'processing_activities>>asset_ropa>>owner_workspace>>metrics>>without_processing_activities',
          'Without processing activities',
        ],
        incomplete_processings: [
          'processing_activities>>asset_ropa>>owner_workspace>>metrics>>incomplete_processings',
          'Incomplete processings',
        ],
        dpia_indications: ['processing_activities>>asset_ropa>>owner_workspace>>metrics>>dpia_indications', 'DPIA indications'],
        third_country_processing: [
          'processing_activities>>asset_ropa>>owner_workspace>>metrics>>third_country_processing',
          'Third-country processing',
        ],
        sensitive_personal_data: [
          'processing_activities>>asset_ropa>>owner_workspace>>metrics>>sensitive_personal_data',
          'Sensitive personal data',
        ],
      },
      pagination_status: ['processing_activities>>asset_ropa>>owner_workspace>>pagination_status', '{{from}}–{{to}} of {{total}} assets'],
      filters: {
        search_placeholder: [
          'processing_activities>>asset_ropa>>owner_workspace>>filters>>search_placeholder',
          'Search assets or processing activities',
        ],
        asset_type: ['processing_activities>>asset_ropa>>owner_workspace>>filters>>asset_type', 'Asset type'],
        completeness: ['processing_activities>>asset_ropa>>owner_workspace>>filters>>completeness', 'Completeness'],
        gdpr_relevance: ['processing_activities>>asset_ropa>>owner_workspace>>filters>>gdpr_relevance', 'GDPR relevance'],
        all: ['processing_activities>>asset_ropa>>owner_workspace>>filters>>all', 'All'],
        reset: ['processing_activities>>asset_ropa>>owner_workspace>>filters>>reset', 'Reset'],
      },
      completeness_status: {
        complete: ['processing_activities>>asset_ropa>>owner_workspace>>completeness_status>>complete', 'Complete'],
        incomplete: ['processing_activities>>asset_ropa>>owner_workspace>>completeness_status>>incomplete', 'Incomplete'],
        no_processing_activities: [
          'processing_activities>>asset_ropa>>owner_workspace>>completeness_status>>no_processing_activities',
          'No processing activities',
        ],
      },
      gdpr_relevance: {
        currently_indicated: [
          'processing_activities>>asset_ropa>>owner_workspace>>gdpr_relevance>>currently_indicated',
          'Currently GDPR relevant',
        ],
        no_longer_indicated: [
          'processing_activities>>asset_ropa>>owner_workspace>>gdpr_relevance>>no_longer_indicated',
          'No longer GDPR indicated',
        ],
        all: ['processing_activities>>asset_ropa>>owner_workspace>>gdpr_relevance>>all', 'All'],
      },
      panel: {
        owner: ['processing_activities>>asset_ropa>>owner_workspace>>panel>>owner', 'Owner'],
        operational_owner: ['processing_activities>>asset_ropa>>owner_workspace>>panel>>operational_owner', 'Operational owner'],
        processing_activities: [
          'processing_activities>>asset_ropa>>owner_workspace>>panel>>processing_activities',
          'Processing activities',
        ],
        updated: ['processing_activities>>asset_ropa>>owner_workspace>>panel>>updated', 'Updated {{date}} by {{user}}'],
        completeness_note: [
          'processing_activities>>asset_ropa>>owner_workspace>>panel>>completeness_note',
          'Completeness is informational only. It helps identify missing documentation and does not create a formal review status.',
        ],
        not_included_in_current_review: [
          'processing_activities>>asset_ropa>>owner_workspace>>panel>>not_included_in_current_review',
          'Not included in current review',
        ],
      },
      table: {
        processing_activity: ['processing_activities>>asset_ropa>>owner_workspace>>table>>processing_activity', 'Processing activity'],
        purposes: ['processing_activities>>asset_ropa>>owner_workspace>>table>>purposes', 'Purposes'],
        completeness: ['processing_activities>>asset_ropa>>owner_workspace>>table>>completeness', 'Completeness'],
        last_updated: ['processing_activities>>asset_ropa>>owner_workspace>>table>>last_updated', 'Last updated'],
        dpia: ['processing_activities>>asset_ropa>>owner_workspace>>table>>dpia', 'DPIA'],
        countries: ['processing_activities>>asset_ropa>>owner_workspace>>table>>countries', 'Countries'],
        review_status: ['processing_activities>>asset_ropa>>owner_workspace>>table>>review_status', 'Review status'],
        row_aria_label: ['processing_activities>>asset_ropa>>owner_workspace>>table>>row_aria_label', 'Open processing activity {{name}}'],
      },
      row_completeness: {
        complete: ['processing_activities>>asset_ropa>>owner_workspace>>row_completeness>>complete', 'Complete'],
        incomplete: ['processing_activities>>asset_ropa>>owner_workspace>>row_completeness>>incomplete', 'Incomplete'],
      },
      new_purpose_badge: ['processing_activities>>asset_ropa>>owner_workspace>>new_purpose_badge', 'New purpose not assessed'],
      actions: {
        remove_from_asset: ['processing_activities>>asset_ropa>>owner_workspace>>actions>>remove_from_asset', 'Remove from asset'],
        open_dpia: ['processing_activities>>asset_ropa>>owner_workspace>>actions>>open_dpia', 'Open DPIA'],
        view_dpia_history: ['processing_activities>>asset_ropa>>owner_workspace>>actions>>view_dpia_history', 'View DPIA history'],
        start_reassessment: ['processing_activities>>asset_ropa>>owner_workspace>>actions>>start_reassessment', 'Start reassessment'],
      },
      previous_dpias_available: [
        'processing_activities>>asset_ropa>>owner_workspace>>previous_dpias_available',
        'Previous DPIAs available',
      ],
      add_processing_activity: {
        title: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>title', 'Add processing activity'],
        select_label: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>select_label', 'Processing activity'],
        search_placeholder: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>search_placeholder',
          'Search by name',
        ],
        confirm: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>confirm', 'Add'],
        empty: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>empty',
          'No published processing activities are available to add.',
        ],
        search_empty: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>search_empty',
          'No processing activities match this search.',
        ],
        load_more: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>load_more', 'Load more'],
        preview_title: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>preview_title',
          'Selected processing activity',
        ],
        published_version: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>published_version',
          'Published version {{number}}',
        ],
        purposes: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>purposes', 'Purposes'],
        data_subject_categories: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>data_subject_categories',
          'Data subject categories',
        ],
        personal_data_categories: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>personal_data_categories',
          'Personal data categories',
        ],
        recipient_categories: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>recipient_categories',
          'Recipient categories',
        ],
        unavailable: [
          'processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>unavailable',
          'The selected processing activity is no longer available. Refresh the search results and try again.',
        ],
        refresh: ['processing_activities>>asset_ropa>>owner_workspace>>add_processing_activity>>refresh', 'Refresh results'],
      },
      soft_delete: {
        title: ['processing_activities>>asset_ropa>>owner_workspace>>soft_delete>>title', 'Remove from asset'],
        reason: ['processing_activities>>asset_ropa>>owner_workspace>>soft_delete>>reason', 'Reason for removal'],
        help: [
          'processing_activities>>asset_ropa>>owner_workspace>>soft_delete>>help',
          'Enter a reason before removing the processing activity from the asset.',
        ],
        confirm: ['processing_activities>>asset_ropa>>owner_workspace>>soft_delete>>confirm', 'Remove'],
      },
      toasts: {
        added: ['processing_activities>>asset_ropa>>owner_workspace>>toasts>>added', 'Processing activity added.'],
        add_failed: ['processing_activities>>asset_ropa>>owner_workspace>>toasts>>add_failed', 'Could not add the processing activity.'],
        removed: ['processing_activities>>asset_ropa>>owner_workspace>>toasts>>removed', 'Processing activity removed from the asset.'],
        remove_failed: [
          'processing_activities>>asset_ropa>>owner_workspace>>toasts>>remove_failed',
          'Could not remove the processing activity.',
        ],
        reassessed: ['processing_activities>>asset_ropa>>owner_workspace>>toasts>>reassessed', 'DPIA reassessment started.'],
        reassess_failed: [
          'processing_activities>>asset_ropa>>owner_workspace>>toasts>>reassess_failed',
          'Could not start the DPIA reassessment.',
        ],
      },
      empty_state: {
        org_wide_title: ['processing_activities>>asset_ropa>>owner_workspace>>empty_state>>org_wide_title', 'No assets assigned to you'],
        org_wide_body: [
          'processing_activities>>asset_ropa>>owner_workspace>>empty_state>>org_wide_body',
          'You do not have any GDPR-relevant assets in your organization yet.',
        ],
        filtered_title: [
          'processing_activities>>asset_ropa>>owner_workspace>>empty_state>>filtered_title',
          'No assets match the current filters',
        ],
        filtered_body: [
          'processing_activities>>asset_ropa>>owner_workspace>>empty_state>>filtered_body',
          'Try adjusting your search or filters.',
        ],
        clear_filters: ['processing_activities>>asset_ropa>>owner_workspace>>empty_state>>clear_filters', 'Clear filters'],
      },
      overlay_empty_state: {
        no_processing_activities: [
          'processing_activities>>asset_ropa>>owner_workspace>>overlay_empty_state>>no_processing_activities',
          'No processing activities are linked to this asset yet.',
        ],
        awaiting_submission: [
          'processing_activities>>asset_ropa>>owner_workspace>>overlay_empty_state>>awaiting_submission',
          'Add or update processing activities before submitting this asset for review.',
        ],
      },
    },
    empty_state: {
      no_active_review_title: ['processing_activities>>asset_ropa>>empty_state>>no_active_review_title', 'No active ROPA review'],
      no_active_review_body: [
        'processing_activities>>asset_ropa>>empty_state>>no_active_review_body',
        'Start a ROPA review from this page to include all GDPR-relevant assets. Permanent Asset ROPA is maintained by owners in their workspace outside review rounds.',
      ],
      eligible_assets_summary: [
        'processing_activities>>asset_ropa>>empty_state>>eligible_assets_summary',
        '{{assets}} eligible assets · {{owners}} operational owners · {{apas}} asset processing activities',
      ],
      open_owner_workspace: ['processing_activities>>asset_ropa>>empty_state>>open_owner_workspace', 'Open owner Asset ROPA workspace'],
      owner_no_active_review_title: [
        'processing_activities>>asset_ropa>>empty_state>>owner_no_active_review_title',
        'No active ROPA review includes your assets',
      ],
      owner_no_active_review_body: [
        'processing_activities>>asset_ropa>>empty_state>>owner_no_active_review_body',
        'When an administrator starts a ROPA review that includes your assets, they will appear here.',
      ],
      no_assets_title: ['processing_activities>>asset_ropa>>empty_state>>no_assets_title', 'No assets match the current filters'],
      no_assets_body: ['processing_activities>>asset_ropa>>empty_state>>no_assets_body', 'Try adjusting your search or filters.'],
      no_inventory_title: ['processing_activities>>asset_ropa>>empty_state>>no_inventory_title', 'No GDPR-relevant Asset ROPAs'],
      no_inventory_body: [
        'processing_activities>>asset_ropa>>empty_state>>no_inventory_body',
        'There are no GDPR-relevant assets in this organisation yet.',
      ],
      no_review_history: ['processing_activities>>asset_ropa>>empty_state>>no_review_history', 'No review history'],
    },
    forbidden_title: ['processing_activities>>asset_ropa>>forbidden_title', 'Access denied'],
    forbidden_body: [
      'processing_activities>>asset_ropa>>forbidden_body',
      'You need ROPA administrator permission to manage Asset ROPA reviews.',
    ],
    owner_forbidden_body: [
      'processing_activities>>asset_ropa>>owner_forbidden_body',
      'You need asset owner access to review your Asset ROPA workspaces. This permission is provided by the backend when available.',
    ],
    actions: {
      back: ['processing_activities>>asset_ropa>>actions>>back', 'Back to processing activities'],
      start_review: ['processing_activities>>asset_ropa>>actions>>start_review', 'Start ROPA review'],
      open_asset_ropa: ['processing_activities>>asset_ropa>>actions>>open_asset_ropa', 'Open Asset ROPA'],
      edit_review: ['processing_activities>>asset_ropa>>actions>>edit_review', 'Edit review details'],
      complete_review: ['processing_activities>>asset_ropa>>actions>>complete_review', 'Complete review'],
      cancel_review: ['processing_activities>>asset_ropa>>actions>>cancel_review', 'Cancel review'],
      add_processing_activity: ['processing_activities>>asset_ropa>>actions>>add_processing_activity', 'Add processing activity'],
      confirm_none_apply: ['processing_activities>>asset_ropa>>actions>>confirm_none_apply', 'Confirm none apply'],
      accept_all_submitted: ['processing_activities>>asset_ropa>>actions>>accept_all_submitted', 'Accept all submitted reviews'],
      accept: ['processing_activities>>asset_ropa>>actions>>accept', 'Accept'],
      request_clarification: ['processing_activities>>asset_ropa>>actions>>request_clarification', 'Request clarification'],
      open: ['processing_activities>>asset_ropa>>actions>>open', 'Open'],
      edit: ['processing_activities>>asset_ropa>>actions>>edit', 'Edit'],
      cancel_incomplete_asset_review: [
        'processing_activities>>asset_ropa>>actions>>cancel_incomplete_asset_review',
        'Cancel incomplete asset review',
      ],
      asset_menu: ['processing_activities>>asset_ropa>>actions>>asset_menu', 'Asset actions'],
      row_menu: ['processing_activities>>asset_ropa>>actions>>row_menu', 'Processing activity review actions'],
      go_to_ropa_review: ['processing_activities>>asset_ropa>>actions>>go_to_ropa_review', 'ROPA review'],
    },
    active_review: {
      eyebrow: ['processing_activities>>asset_ropa>>active_review>>eyebrow', 'Active ROPA review'],
      title: ['processing_activities>>asset_ropa>>active_review>>title', 'Organisation ROPA review'],
      initiated: ['processing_activities>>asset_ropa>>active_review>>initiated', 'Initiated'],
      deadline: ['processing_activities>>asset_ropa>>active_review>>deadline', 'Deadline'],
      status: ['processing_activities>>asset_ropa>>active_review>>status', 'Status'],
      initiated_by: ['processing_activities>>asset_ropa>>active_review>>initiated_by', 'Initiated by'],
      membership_label: ['processing_activities>>asset_ropa>>active_review>>membership_label', 'Member #{{id}}'],
      unknown_initiator: ['processing_activities>>asset_ropa>>active_review>>unknown_initiator', 'Unknown'],
      instructions_summary: ['processing_activities>>asset_ropa>>active_review>>instructions_summary', 'Review instructions'],
    },
    round_status: {
      active: ['processing_activities>>asset_ropa>>round_status>>active', 'Active'],
      completed: ['processing_activities>>asset_ropa>>round_status>>completed', 'Completed'],
      cancelled: ['processing_activities>>asset_ropa>>round_status>>cancelled', 'Cancelled'],
    },
    closure: {
      completed_title: ['processing_activities>>asset_ropa>>closure>>completed_title', 'ROPA review completed'],
      completed_body: [
        'processing_activities>>asset_ropa>>closure>>completed_body',
        'This review round is closed. Review actions are no longer available.',
      ],
      cancelled_title: ['processing_activities>>asset_ropa>>closure>>cancelled_title', 'ROPA review cancelled'],
      cancelled_body: [
        'processing_activities>>asset_ropa>>closure>>cancelled_body',
        'This review round was cancelled. Review actions are no longer available.',
      ],
      completion_comment: ['processing_activities>>asset_ropa>>closure>>completion_comment', 'Completion comment'],
      cancellation_comment: ['processing_activities>>asset_ropa>>closure>>cancellation_comment', 'Cancellation comment'],
    },
    metrics: {
      aria_label: ['processing_activities>>asset_ropa>>metrics>>aria_label', 'ROPA review metrics'],
      included_assets: ['processing_activities>>asset_ropa>>metrics>>included_assets', 'Included assets'],
      owner_included_assets: ['processing_activities>>asset_ropa>>metrics>>owner_included_assets', 'My included assets'],
      awaiting_response: ['processing_activities>>asset_ropa>>metrics>>awaiting_response', 'Awaiting response'],
      submitted: ['processing_activities>>asset_ropa>>metrics>>submitted', 'Submitted'],
      accepted: ['processing_activities>>asset_ropa>>metrics>>accepted', 'Accepted'],
      clarification_requested: ['processing_activities>>asset_ropa>>metrics>>clarification_requested', 'Clarification requested'],
      assets_with_warnings: ['processing_activities>>asset_ropa>>metrics>>assets_with_warnings', 'Assets with warnings'],
    },
    filters: {
      search_placeholder: ['processing_activities>>asset_ropa>>filters>>search_placeholder', 'Search assets'],
      review_status: ['processing_activities>>asset_ropa>>filters>>review_status', 'Review status'],
      review_status_all: ['processing_activities>>asset_ropa>>filters>>review_status_all', 'Review status: All'],
      asset_type: ['processing_activities>>asset_ropa>>filters>>asset_type', 'Asset type'],
      asset_type_all: ['processing_activities>>asset_ropa>>filters>>asset_type_all', 'Asset type: All'],
      operational_owner: ['processing_activities>>asset_ropa>>filters>>operational_owner', 'Operational owner'],
      operational_owner_all: ['processing_activities>>asset_ropa>>filters>>operational_owner_all', 'Operational owner: All'],
      warning_state: ['processing_activities>>asset_ropa>>filters>>warning_state', 'Warning state'],
      dpia_state: ['processing_activities>>asset_ropa>>filters>>dpia_state', 'DPIA state'],
      dpia_indication: ['processing_activities>>asset_ropa>>filters>>dpia_indication', 'DPIA indicated'],
      dpia_request: ['processing_activities>>asset_ropa>>filters>>dpia_request', 'DPIA request'],
      dpia_status_lifecycle: ['processing_activities>>asset_ropa>>filters>>dpia_status_lifecycle', 'DPIA status'],
      dpia_dependent_filters_hint: [
        'processing_activities>>asset_ropa>>filters>>dpia_dependent_filters_hint',
        'Available when DPIA indicated is Yes',
      ],
      sensitive_personal_data: ['processing_activities>>asset_ropa>>filters>>sensitive_personal_data', 'Sensitive personal data'],
      third_country_processing: ['processing_activities>>asset_ropa>>filters>>third_country_processing', 'Third-country processing'],
      more_filters: ['processing_activities>>asset_ropa>>filters>>more_filters', 'More filters'],
      all: ['processing_activities>>asset_ropa>>filters>>all', 'All'],
      with_warnings: ['processing_activities>>asset_ropa>>filters>>with_warnings', 'With warnings'],
      no_warnings: ['processing_activities>>asset_ropa>>filters>>no_warnings', 'No warnings'],
      dpia_indicated: ['processing_activities>>asset_ropa>>filters>>dpia_indicated', 'DPIA indicated'],
      dpia_required_unapproved: ['processing_activities>>asset_ropa>>filters>>dpia_required_unapproved', 'DPIA required, not approved'],
      dpia_none: ['processing_activities>>asset_ropa>>filters>>dpia_none', 'No DPIA flags'],
      yes: ['processing_activities>>asset_ropa>>filters>>yes', 'Yes'],
      no: ['processing_activities>>asset_ropa>>filters>>no', 'No'],
    },
    review_status: {
      awaiting_response: ['processing_activities>>asset_ropa>>review_status>>awaiting_response', 'Awaiting response'],
      submitted: ['processing_activities>>asset_ropa>>review_status>>submitted', 'Submitted'],
      accepted: ['processing_activities>>asset_ropa>>review_status>>accepted', 'Accepted'],
      clarification_requested: ['processing_activities>>asset_ropa>>review_status>>clarification_requested', 'Clarification requested'],
      cancelled: ['processing_activities>>asset_ropa>>review_status>>cancelled', 'Cancelled'],
    },
    permanent_ropa_status: {
      not_started: ['processing_activities>>asset_ropa>>permanent_ropa_status>>not_started', 'Not started'],
      in_progress: ['processing_activities>>asset_ropa>>permanent_ropa_status>>in_progress', 'In progress'],
      complete: ['processing_activities>>asset_ropa>>permanent_ropa_status>>complete', 'Complete'],
      not_requested: ['processing_activities>>asset_ropa>>permanent_ropa_status>>not_requested', 'Not requested'],
      awaiting_response: ['processing_activities>>asset_ropa>>permanent_ropa_status>>awaiting_response', 'Awaiting response'],
      submitted: ['processing_activities>>asset_ropa>>permanent_ropa_status>>submitted', 'Submitted'],
      clarification_requested: [
        'processing_activities>>asset_ropa>>permanent_ropa_status>>clarification_requested',
        'Clarification requested',
      ],
      accepted: ['processing_activities>>asset_ropa>>permanent_ropa_status>>accepted', 'Accepted'],
    },
    warnings: {
      dpia_indicated: ['processing_activities>>asset_ropa>>warnings>>dpia_indicated', 'DPIA indicated'],
      dpia_required_unapproved: ['processing_activities>>asset_ropa>>warnings>>dpia_required_unapproved', 'DPIA required'],
      third_country_processing: ['processing_activities>>asset_ropa>>warnings>>third_country_processing', 'Third-country processing'],
      sensitive_personal_data: ['processing_activities>>asset_ropa>>warnings>>sensitive_personal_data', 'Sensitive personal data'],
      confirmed_no_processing_activities: [
        'processing_activities>>asset_ropa>>warnings>>confirmed_no_processing_activities',
        'No processing activities confirmed',
      ],
    },
    panel: {
      operational_owner: ['processing_activities>>asset_ropa>>panel>>operational_owner', 'Operational owner'],
      asset_type: ['processing_activities>>asset_ropa>>panel>>asset_type', 'Asset type'],
      processing_activities: ['processing_activities>>asset_ropa>>panel>>processing_activities', 'Processing activities'],
      ropa_status: ['processing_activities>>asset_ropa>>panel>>ropa_status', 'ROPA status'],
      not_assigned: ['processing_activities>>asset_ropa>>panel>>not_assigned', 'Not assigned'],
      individual_review_required: [
        'processing_activities>>asset_ropa>>panel>>individual_review_required',
        'Review each processing activity separately before accepting submitted reviews for this asset.',
      ],
      no_blocking_warnings: ['processing_activities>>asset_ropa>>panel>>no_blocking_warnings', 'No blocking warning flags are present.'],
      no_processing_activities_title: [
        'processing_activities>>asset_ropa>>panel>>no_processing_activities_title',
        'No processing activities are linked',
      ],
      no_processing_activities_body: [
        'processing_activities>>asset_ropa>>panel>>no_processing_activities_body',
        'Add a processing activity or confirm that no processing activities apply to this asset.',
      ],
    },
    table: {
      aria_label: ['processing_activities>>asset_ropa>>table>>aria_label', 'Asset ROPA processing activities table'],
      processing_activity: ['processing_activities>>asset_ropa>>table>>processing_activity', 'Processing activity'],
      review_status: ['processing_activities>>asset_ropa>>table>>review_status', 'Review status'],
      active_purposes: ['processing_activities>>asset_ropa>>table>>active_purposes', 'Active purposes'],
      dpia_status: ['processing_activities>>asset_ropa>>table>>dpia_status', 'DPIA status'],
      last_updated: ['processing_activities>>asset_ropa>>table>>last_updated', 'Last updated'],
      row_aria_label: ['processing_activities>>asset_ropa>>table>>row_aria_label', 'Open processing activity {{name}}'],
    },
    assets_table: {
      aria_label: ['processing_activities>>asset_ropa>>assets_table>>aria_label', 'Asset ROPA assets table'],
      asset: ['processing_activities>>asset_ropa>>assets_table>>asset', 'Asset'],
      owner: ['processing_activities>>asset_ropa>>assets_table>>owner', 'Operational owner'],
      asset_type: ['processing_activities>>asset_ropa>>assets_table>>asset_type', 'Asset type'],
      processing_activities: ['processing_activities>>asset_ropa>>assets_table>>processing_activities', 'Processing activities'],
      ropa_status: ['processing_activities>>asset_ropa>>assets_table>>ropa_status', 'Review priority'],
      review_status: ['processing_activities>>asset_ropa>>assets_table>>review_status', 'Review status'],
      warnings: ['processing_activities>>asset_ropa>>assets_table>>warnings', 'Warnings'],
      row_aria_label: ['processing_activities>>asset_ropa>>assets_table>>row_aria_label', 'Expand asset {{name}}'],
    },
    dpia_request_status: {
      draft: ['processing_activities>>asset_ropa>>dpia_request_status>>draft', 'Draft (RA)'],
      decided_dpia_required: ['processing_activities>>asset_ropa>>dpia_request_status>>decided_dpia_required', 'DPIA required'],
      decided_dpia_not_required: ['processing_activities>>asset_ropa>>dpia_request_status>>decided_dpia_not_required', 'DPIA not required'],
    },
    dpia_status: {
      indicated: ['processing_activities>>asset_ropa>>dpia_status>>indicated', 'DPIA indicated'],
      not_indicated: ['processing_activities>>asset_ropa>>dpia_status>>not_indicated', 'DPIA not indicated'],
      required: ['processing_activities>>asset_ropa>>dpia_status>>required', 'DPIA required'],
      not_required: ['processing_activities>>asset_ropa>>dpia_status>>not_required', 'DPIA not required'],
      dpia_required: ['processing_activities>>asset_ropa>>dpia_status>>dpia_required', 'DPIA required'],
      dpia_not_required: ['processing_activities>>asset_ropa>>dpia_status>>dpia_not_required', 'DPIA not required'],
      draft: ['processing_activities>>asset_ropa>>dpia_status>>draft', 'Draft (AO)'],
      draft_ra: ['processing_activities>>asset_ropa>>dpia_status>>draft_ra', 'Draft (RA)'],
      draft_ao: ['processing_activities>>asset_ropa>>dpia_status>>draft_ao', 'Draft (AO)'],
      decision_made: ['processing_activities>>asset_ropa>>dpia_status>>decision_made', 'Decision made'],
      in_progress: ['processing_activities>>asset_ropa>>dpia_status>>in_progress', 'In progress (AO)'],
      ready_for_review: ['processing_activities>>asset_ropa>>dpia_status>>ready_for_review', 'Ready for RA review'],
      clarification_requested: ['processing_activities>>asset_ropa>>dpia_status>>clarification_requested', 'AO clarification requested'],
    },
    bulk_accept: {
      unavailable_prefix: ['processing_activities>>asset_ropa>>bulk_accept>>unavailable_prefix', 'Bulk acceptance unavailable:'],
      confirm_title: ['processing_activities>>asset_ropa>>bulk_accept>>confirm_title', 'Accept submitted reviews'],
      confirm_body: ['processing_activities>>asset_ropa>>bulk_accept>>confirm_body', 'Accept {{count}} submitted reviews for this asset?'],
      block_reasons: {
        dpia_indicated: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>dpia_indicated',
          'DPIA indication requires individual review.',
        ],
        dpia_required_unapproved: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>dpia_required_unapproved',
          'Required but unapproved DPIA requires individual review.',
        ],
        third_country_processing: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>third_country_processing',
          'Third-country processing requires individual review.',
        ],
        sensitive_personal_data: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>sensitive_personal_data',
          'Sensitive personal data requires individual review.',
        ],
        clarification_requested: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>clarification_requested',
          'Clarification requested items require individual review.',
        ],
        no_submitted_reviews: [
          'processing_activities>>asset_ropa>>bulk_accept>>block_reasons>>no_submitted_reviews',
          'No submitted reviews are available for bulk acceptance.',
        ],
      },
    },
    modals: {
      start_review: {
        title: ['processing_activities>>asset_ropa>>modals>>start_review>>title', 'Start ROPA review'],
        intro: [
          'processing_activities>>asset_ropa>>modals>>start_review>>intro',
          'Start a formal ROPA review for all GDPR-relevant assets in the organisation.',
        ],
        deadline: ['processing_activities>>asset_ropa>>modals>>start_review>>deadline', 'Deadline'],
        deadline_invalid: [
          'processing_activities>>asset_ropa>>modals>>start_review>>deadline_invalid',
          'Enter a valid date in yyyy-mm-dd format.',
        ],
        deadline_future: ['processing_activities>>asset_ropa>>modals>>start_review>>deadline_future', 'Deadline must be later than today.'],
        deadline_max: [
          'processing_activities>>asset_ropa>>modals>>start_review>>deadline_max',
          'Deadline must not be later than 2999-12-31.',
        ],
        instructions: ['processing_activities>>asset_ropa>>modals>>start_review>>instructions', 'Review instructions'],
        instructions_help: [
          'processing_activities>>asset_ropa>>modals>>start_review>>instructions_help',
          'Provide plain-text instructions for asset owners. Line breaks are preserved.',
        ],
        summary_loading: ['processing_activities>>asset_ropa>>modals>>start_review>>summary_loading', 'Loading review scope…'],
        summary: [
          'processing_activities>>asset_ropa>>modals>>start_review>>summary',
          '{{assets}} assets · {{owners}} operational owners · {{activities}} asset processing activities',
        ],
        confirm: ['processing_activities>>asset_ropa>>modals>>start_review>>confirm', 'Start review'],
      },
      edit_review: {
        title: ['processing_activities>>asset_ropa>>modals>>edit_review>>title', 'Edit review details'],
        confirm: ['processing_activities>>asset_ropa>>modals>>edit_review>>confirm', 'Save changes'],
      },
      complete_review: {
        title: ['processing_activities>>asset_ropa>>modals>>complete_review>>title', 'Complete review'],
        summary_intro: ['processing_activities>>asset_ropa>>modals>>complete_review>>summary_intro', 'Review status summary:'],
        accepted_count: ['processing_activities>>asset_ropa>>modals>>complete_review>>accepted_count', 'Accepted: {{count}}'],
        submitted_count: ['processing_activities>>asset_ropa>>modals>>complete_review>>submitted_count', 'Submitted: {{count}}'],
        awaiting_response_count: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>awaiting_response_count',
          'Awaiting response: {{count}}',
        ],
        clarification_requested_count: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>clarification_requested_count',
          'Clarification requested: {{count}}',
        ],
        rows_to_cancel_count: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>rows_to_cancel_count',
          'Incomplete rows to cancel: {{count}}',
        ],
        comment: ['processing_activities>>asset_ropa>>modals>>complete_review>>comment', 'Completion comment'],
        comment_help: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>comment_help',
          'A comment is required when incomplete review rows remain.',
        ],
        comment_help_required: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>comment_help_required',
          'A completion comment is required.',
        ],
        disclaimer: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>disclaimer',
          'Incomplete review rows will be cancelled. Accepted rows remain accepted. Follow-up is handled outside this review round.',
        ],
        confirm: ['processing_activities>>asset_ropa>>modals>>complete_review>>confirm', 'Complete review'],
        incomplete_confirm_title: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>incomplete_confirm_title',
          'Unfinished reviews remaining',
        ],
        incomplete_confirm_body: [
          'processing_activities>>asset_ropa>>modals>>complete_review>>incomplete_confirm_body',
          'There are {{count}} unfinished review rows (submitted, awaiting response, or clarification requested). They will be cancelled. Are you sure you want to complete this review?',
        ],
      },
      cancel_review: {
        title: ['processing_activities>>asset_ropa>>modals>>cancel_review>>title', 'Cancel review'],
        comment: ['processing_activities>>asset_ropa>>modals>>cancel_review>>comment', 'Cancellation comment'],
        help: ['processing_activities>>asset_ropa>>modals>>cancel_review>>help', 'Explain why the review is being cancelled.'],
        warning: [
          'processing_activities>>asset_ropa>>modals>>cancel_review>>warning',
          'This action cancels the entire ROPA review round. All incomplete review rows will be cancelled.',
        ],
        summary_intro: ['processing_activities>>asset_ropa>>modals>>cancel_review>>summary_intro', 'Current review status:'],
        confirm: ['processing_activities>>asset_ropa>>modals>>cancel_review>>confirm', 'Cancel review'],
      },
      clarification: {
        title: ['processing_activities>>asset_ropa>>modals>>clarification>>title', 'Request clarification'],
        comment: ['processing_activities>>asset_ropa>>modals>>clarification>>comment', 'Clarification comment'],
        help: ['processing_activities>>asset_ropa>>modals>>clarification>>help', 'Describe what needs to be clarified before acceptance.'],
        confirm: ['processing_activities>>asset_ropa>>modals>>clarification>>confirm', 'Send request'],
      },
      reassess: {
        title: ['processing_activities>>asset_ropa>>modals>>reassess>>title', 'Start DPIA reassessment'],
        reason: ['processing_activities>>asset_ropa>>modals>>reassess>>reason', 'Reason'],
        help: [
          'processing_activities>>asset_ropa>>modals>>reassess>>help',
          'Explain why a new DPIA is needed. The current approved DPIA stays in history.',
        ],
        confirm: ['processing_activities>>asset_ropa>>modals>>reassess>>confirm', 'Start reassessment'],
      },
      cancel_incomplete_asset_review: {
        title: ['processing_activities>>asset_ropa>>modals>>cancel_incomplete_asset_review>>title', 'Cancel incomplete asset review'],
        help: [
          'processing_activities>>asset_ropa>>modals>>cancel_incomplete_asset_review>>help',
          'Explain why this asset review is being cancelled.',
        ],
        confirm: ['processing_activities>>asset_ropa>>modals>>cancel_incomplete_asset_review>>confirm', 'Cancel asset review'],
      },
    },
    toasts: {
      review_started: ['processing_activities>>asset_ropa>>toasts>>review_started', 'ROPA review started.'],
      review_updated: ['processing_activities>>asset_ropa>>toasts>>review_updated', 'Review details updated.'],
      review_accepted: ['processing_activities>>asset_ropa>>toasts>>review_accepted', 'Review accepted.'],
      clarification_requested: ['processing_activities>>asset_ropa>>toasts>>clarification_requested', 'Clarification requested.'],
      clarification_none_eligible: [
        'processing_activities>>asset_ropa>>toasts>>clarification_none_eligible',
        'No submitted reviews on this asset can receive a clarification request.',
      ],
      bulk_accepted: ['processing_activities>>asset_ropa>>toasts>>bulk_accepted', 'Submitted reviews accepted for the asset.'],
      processing_activity_added: [
        'processing_activities>>asset_ropa>>toasts>>processing_activity_added',
        'Processing activity added to the asset.',
      ],
      review_completed: ['processing_activities>>asset_ropa>>toasts>>review_completed', 'ROPA review completed.'],
      review_cancelled: ['processing_activities>>asset_ropa>>toasts>>review_cancelled', 'ROPA review cancelled.'],
      confirm_none_apply: [
        'processing_activities>>asset_ropa>>toasts>>confirm_none_apply',
        'Confirmed that no processing activities apply to this asset.',
      ],
      asset_review_cancelled: ['processing_activities>>asset_ropa>>toasts>>asset_review_cancelled', 'Incomplete asset review cancelled.'],
      start_review_failed: ['processing_activities>>asset_ropa>>toasts>>start_review_failed', 'The ROPA review could not be started.'],
      action_failed: ['processing_activities>>asset_ropa>>toasts>>action_failed', 'The action could not be completed. Try again.'],
      reassessed: ['processing_activities>>asset_ropa>>toasts>>reassessed', 'DPIA reassessment started.'],
      reassess_failed: ['processing_activities>>asset_ropa>>toasts>>reassess_failed', 'Could not start the DPIA reassessment.'],
    },
    errors: {
      load_failed: ['processing_activities>>asset_ropa>>errors>>load_failed', 'Asset ROPA data could not be loaded. Try again.'],
    },
    apa_side_panel: {
      title: ['processing_activities>>asset_ropa>>apa_side_panel>>title', 'Processing activity'],
      read_only_note: ['processing_activities>>asset_ropa>>apa_side_panel>>read_only_note', 'Central processing activity (read-only)'],
      name: ['processing_activities>>asset_ropa>>apa_side_panel>>name', 'Name'],
      description: ['processing_activities>>asset_ropa>>apa_side_panel>>description', 'Description'],
      processing_role: ['processing_activities>>asset_ropa>>apa_side_panel>>processing_role', 'Processing role'],
      data_subjects: ['processing_activities>>asset_ropa>>apa_side_panel>>data_subjects', 'Data subjects'],
      personal_data: ['processing_activities>>asset_ropa>>apa_side_panel>>personal_data', 'Personal data categories'],
      recipients: ['processing_activities>>asset_ropa>>apa_side_panel>>recipients', 'Recipient categories'],
      minimum_security: ['processing_activities>>asset_ropa>>apa_side_panel>>minimum_security', 'Minimum security measures'],
      legal_basis: ['processing_activities>>asset_ropa>>apa_side_panel>>legal_basis', 'Legal basis'],
      legal_basis_comment: ['processing_activities>>asset_ropa>>apa_side_panel>>legal_basis_comment', 'Legal basis comment'],
      lia_required: ['processing_activities>>asset_ropa>>apa_side_panel>>lia_required', 'LIA required'],
      retention_rule: ['processing_activities>>asset_ropa>>apa_side_panel>>retention_rule', 'Retention rule'],
      retention_trigger: ['processing_activities>>asset_ropa>>apa_side_panel>>retention_trigger', 'Trigger'],
      retention_period_and_unit: ['processing_activities>>asset_ropa>>apa_side_panel>>retention_period_and_unit', 'Period and unit'],
      retention_comment: ['processing_activities>>asset_ropa>>apa_side_panel>>retention_comment', 'Comment'],
      yes: ['processing_activities>>asset_ropa>>apa_side_panel>>yes', 'Yes'],
      no: ['processing_activities>>asset_ropa>>apa_side_panel>>no', 'No'],
    },
    apa_review: {
      page_title: ['processing_activities>>asset_ropa>>apa_review>>page_title', 'Review asset processing activity'],
      page_subtitle: [
        'processing_activities>>asset_ropa>>apa_review>>page_subtitle',
        'Review the submitted asset processing activity before acceptance or clarification.',
      ],
      errors: {
        not_found: [
          'processing_activities>>asset_ropa>>apa_review>>errors>>not_found',
          'This asset processing activity review is not available. It may have been removed, or you may not have access.',
        ],
      },
      changed_after_submission: ['processing_activities>>asset_ropa>>apa_review>>changed_after_submission', 'Changed after submission'],
      accept_blocked: [
        'processing_activities>>asset_ropa>>apa_review>>accept_blocked',
        'Accept is blocked until the asset owner resubmits after changes.',
      ],
      clarification_comment: ['processing_activities>>asset_ropa>>apa_review>>clarification_comment', 'Clarification comment'],
      owner_response: ['processing_activities>>asset_ropa>>apa_review>>owner_response', 'Owner response'],
      asset_section_title: ['processing_activities>>asset_ropa>>apa_review>>asset_section_title', 'Asset processing activity'],
      security_comment: ['processing_activities>>asset_ropa>>apa_review>>security_comment', 'Security comment'],
      minimum_security_assessment: [
        'processing_activities>>asset_ropa>>apa_review>>minimum_security_assessment',
        'Minimum security assessment',
      ],
      dpia_indication: ['processing_activities>>asset_ropa>>apa_review>>dpia_indication', 'DPIA indication'],
      submitted_revision: ['processing_activities>>asset_ropa>>apa_review>>submitted_revision', 'Submitted revision: {{revision}}'],
      current_revision: ['processing_activities>>asset_ropa>>apa_review>>current_revision', 'Current revision: {{revision}}'],
      submitted_at: ['processing_activities>>asset_ropa>>apa_review>>submitted_at', 'Submitted at: {{date}}'],
      submitted_by: ['processing_activities>>asset_ropa>>apa_review>>submitted_by', 'Submitted by: {{name}}'],
      former_organisation_member: [
        'processing_activities>>asset_ropa>>apa_review>>former_organisation_member',
        'Former organisation member',
      ],
      accept_comment: ['processing_activities>>asset_ropa>>apa_review>>accept_comment', 'Acceptance comment (optional)'],
      assess_dpia: ['processing_activities>>asset_ropa>>apa_review>>assess_dpia', 'Assess DPIA indication'],
      start_reassessment: ['processing_activities>>asset_ropa>>apa_review>>start_reassessment', 'Start reassessment'],
      open_admin_dpia_review: ['processing_activities>>asset_ropa>>apa_review>>open_admin_dpia_review', 'Open admin DPIA review'],
      disabled_tooltips: {
        accept_awaiting_response: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>accept_awaiting_response',
          'Accept is available after the asset owner submits this review.',
        ],
        accept_clarification_requested: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>accept_clarification_requested',
          'Accept is available after the asset owner resubmits following clarification.',
        ],
        accept_already_accepted: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>accept_already_accepted',
          'This review has already been accepted.',
        ],
        accept_unavailable: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>accept_unavailable',
          'Accept is not available for the current review status.',
        ],
        clarification_awaiting_response: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>clarification_awaiting_response',
          'Clarification can be requested after the asset owner submits this review.',
        ],
        clarification_already_requested: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>clarification_already_requested',
          'A clarification request is already pending for this review.',
        ],
        clarification_already_accepted: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>clarification_already_accepted',
          'Clarification cannot be requested after the review has been accepted.',
        ],
        clarification_unavailable: [
          'processing_activities>>asset_ropa>>apa_review>>disabled_tooltips>>clarification_unavailable',
          'Clarification is not available for the current review status.',
        ],
      },
      truth_note: [
        'processing_activities>>asset_ropa>>apa_review>>truth_note',
        'Accepting this review confirms that the information has been reviewed and reported. It does not mean identified deficiencies have been remediated.',
      ],
      toasts: {
        accepted: ['processing_activities>>asset_ropa>>apa_review>>toasts>>accepted', 'Review accepted.'],
        clarification_requested: [
          'processing_activities>>asset_ropa>>apa_review>>toasts>>clarification_requested',
          'Clarification requested.',
        ],
        assess_dpia_mock: [
          'processing_activities>>asset_ropa>>apa_review>>toasts>>assess_dpia_mock',
          'DPIA assessment will open in a separate workflow when available.',
        ],
      },
    },
    dpia_need_assessment: {
      page_title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>page_title', 'DPIA need assessment'],
      page_subtitle: [
        'processing_activities>>asset_ropa>>dpia_need_assessment>>page_subtitle',
        'Assess whether a data protection impact assessment should be conducted.',
      ],
      banner_title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>banner_title', 'Assess whether a DPIA should be conducted'],
      request_status: ['processing_activities>>asset_ropa>>dpia_need_assessment>>request_status', 'Request status'],
      asset_owner: ['processing_activities>>asset_ropa>>dpia_need_assessment>>asset_owner', 'Asset owner'],
      dpia_indication: ['processing_activities>>asset_ropa>>dpia_need_assessment>>dpia_indication', 'Current DPIA indication'],
      previous_requests: ['processing_activities>>asset_ropa>>dpia_need_assessment>>previous_requests', 'Previous requests'],
      previous_dpias: ['processing_activities>>asset_ropa>>dpia_need_assessment>>previous_dpias', 'Previous DPIAs'],
      truth_note: [
        'processing_activities>>asset_ropa>>dpia_need_assessment>>truth_note',
        'The system provides decision support. The organization remains responsible for assessing and documenting whether a DPIA shall be conducted.',
      ],
      history_title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>history_title', 'History'],
      dpia_versions_title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>dpia_versions_title', 'DPIA versions'],
      history_need_assessment: ['processing_activities>>asset_ropa>>dpia_need_assessment>>history_need_assessment', 'DPIA need assessment'],
      history_decision: ['processing_activities>>asset_ropa>>dpia_need_assessment>>history_decision', 'Decision'],
      history_status: ['processing_activities>>asset_ropa>>dpia_need_assessment>>history_status', 'Status'],
      side_panel: {
        eyebrow: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>eyebrow', 'Read-only context'],
        title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>title', 'Asset processing activity'],
        active: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>active', 'Active'],
        asset: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>asset', 'Asset'],
        processing_activity: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>processing_activity',
          'Processing activity',
        ],
        asset_owner: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>asset_owner', 'Asset owner'],
        data_subjects: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>data_subjects',
          'Categories of data subjects',
        ],
        personal_data: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>personal_data',
          'Categories of personal data',
        ],
        active_purposes: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>active_purposes', 'Active purposes'],
        countries: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>countries', 'Country handling'],
        minimum_security: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>minimum_security',
          'Minimum security assessment',
        ],
        indicators: ['processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>indicators', 'Current indicators'],
        third_country_access: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>third_country_access',
          'Third-country access',
        ],
        dpia_indicated: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>dpia_indicated',
          'DPIA indicated by asset owner',
        ],
        minimum_security_partial: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>minimum_security_partial',
          'Minimum security partially met',
        ],
        sensitive_personal_data: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>side_panel>>sensitive_personal_data',
          'Sensitive personal data flagged on asset',
        ],
      },
      errors: {
        not_found: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>errors>>not_found',
          'The DPIA need assessment could not be found.',
        ],
        not_editable: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>errors>>not_editable',
          'The DPIA need assessment is no longer editable.',
        ],
        missing_operational_owner: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>errors>>missing_operational_owner',
          'Set operational owner on Asset ROPA before initiating DPIA.',
        ],
        missing_request: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>errors>>missing_request',
          'Open this DPIA need assessment from the related DPIA or from a shared link that includes the request id.',
        ],
        already_in_progress: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>errors>>already_in_progress',
          'A DPIA is already in progress for this processing activity. Open the existing DPIA instead of starting a new need assessment.',
        ],
      },
      save_and_continue: ['processing_activities>>asset_ropa>>dpia_need_assessment>>save_and_continue', 'Save and continue'],
      cancel_request: ['processing_activities>>asset_ropa>>dpia_need_assessment>>cancel_request', 'Cancel request'],
      close: ['processing_activities>>asset_ropa>>dpia_need_assessment>>close', 'Close'],
      sections: {
        trigger: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>trigger>>title', 'Assessment trigger'],
          source: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>trigger>>source', 'Assessment trigger'],
          comment: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>trigger>>comment',
            'Assessment trigger description',
          ],
        },
        criteria: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>criteria>>title', 'Screening criteria'],
          selected_count: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>criteria>>selected_count',
            '{{count}} selected',
          ],
          comment: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>criteria>>comment', 'Assessment comment'],
          criterion_ten_help: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>criteria>>criterion_ten_help',
            'Counts as one selected screening criterion. It does not automatically override the recommendation logic.',
          ],
        },
        always_rule: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>always_rule>>title', 'Always-DPIA rule'],
          checkbox: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>always_rule>>checkbox',
            'An applicable rule requires a DPIA regardless of the selected criteria',
          ],
          help: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>always_rule>>help',
            'Use this when a specific IMY rule, other binding rule or internal policy means that a DPIA should be conducted even if few criteria are selected.',
          ],
          comment: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>always_rule>>comment', 'Always-DPIA rule comment'],
        },
        recommendation: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>recommendation>>title', 'System recommendation'],
          selected_criteria: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>recommendation>>selected_criteria',
            'Selected criteria',
          ],
          always_rule: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>recommendation>>always_rule',
            'Always-DPIA rule',
          ],
          notice: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>recommendation>>notice',
            'Decision support only. The system recommendation does not make the legal decision.',
          ],
        },
        decision: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>title', 'Decision'],
          required: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>required', 'DPIA shall be conducted'],
          not_required: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>not_required',
            'DPIA is not required',
          ],
          comment: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>comment', 'Decision justification'],
          assessed_by: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>assessed_by', 'Assessed by'],
          assessed_at: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>assessed_at', 'Assessment date'],
          deviation_warning: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>deviation_warning',
            'The decision differs from the system recommendation. Provide a clear justification.',
          ],
          summary_title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>summary_title', 'Final summary'],
          responsible_owner: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>responsible_owner',
            'Responsible owner for created DPIA',
          ],
          created_dpia_title: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>created_dpia_title',
            'Created DPIA title',
          ],
          confirm_required: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>confirm_required',
            'Confirm DPIA',
          ],
          confirm_not_required: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>sections>>decision>>confirm_not_required',
            'Confirm DPIA',
          ],
        },
      },
      trigger_sources: {
        asset_owner_indication: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>asset_owner_indication',
          'Asset owner indication',
        ],
        ropa_administrator: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>ropa_administrator',
          'ROPA administrator',
        ],
        formal_ropa_review: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>formal_ropa_review',
          'Formal ROPA review',
        ],
        project_or_change: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>project_or_change',
          'Project or change',
        ],
        periodic_reassessment: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>periodic_reassessment',
          'Periodic reassessment',
        ],
        other: ['processing_activities>>asset_ropa>>dpia_need_assessment>>trigger_sources>>other', 'Other'],
      },
      criteria: {
        systematic_evaluation_or_profiling: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>systematic_evaluation_or_profiling',
          'Systematic and extensive evaluation or profiling',
        ],
        automated_significant_decisions: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>automated_significant_decisions',
          'Automated decision-making with significant effects',
        ],
        systematic_monitoring: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>systematic_monitoring',
          'Systematic monitoring',
        ],
        sensitive_or_highly_personal_data: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>sensitive_or_highly_personal_data',
          'Sensitive or highly personal data',
        ],
        large_scale_processing: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>large_scale_processing',
          'Large-scale processing',
        ],
        matching_or_combining_datasets: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>matching_or_combining_datasets',
          'Matching or combining datasets',
        ],
        vulnerable_data_subjects: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>vulnerable_data_subjects',
          'Data concerning vulnerable data subjects',
        ],
        innovative_technology_or_use: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>innovative_technology_or_use',
          'New technology or innovative use',
        ],
        prevents_rights_services_or_contracts: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>prevents_rights_services_or_contracts',
          'Processing that prevents rights, services or contracts',
        ],
        other_high_risk_criterion: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>criteria>>other_high_risk_criterion',
          'Other high risk under IMY/EDPB guidance or internal policy',
        ],
      },
      recommendations: {
        normally_not_recommended: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>recommendations>>normally_not_recommended',
          'DPIA does not normally appear necessary',
        ],
        further_assessment_recommended: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>recommendations>>further_assessment_recommended',
          'Further assessment recommended',
        ],
        dpia_recommended: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>recommendations>>dpia_recommended',
          'DPIA is normally recommended',
        ],
        dpia_strongly_recommended: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>recommendations>>dpia_strongly_recommended',
          'DPIA is strongly recommended',
        ],
      },
      statuses: {
        draft: ['processing_activities>>asset_ropa>>dpia_need_assessment>>statuses>>draft', 'Draft'],
        decided_dpia_required: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>statuses>>decided_dpia_required',
          'DPIA shall be conducted',
        ],
        decided_dpia_not_required: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>statuses>>decided_dpia_not_required',
          'DPIA not required',
        ],
        cancelled: ['processing_activities>>asset_ropa>>dpia_need_assessment>>statuses>>cancelled', 'Cancelled'],
      },
      modals: {
        cancel_request: {
          title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>modals>>cancel_request>>title', 'Cancel DPIA need assessment'],
          comment: ['processing_activities>>asset_ropa>>dpia_need_assessment>>modals>>cancel_request>>comment', 'Cancellation comment'],
          help: [
            'processing_activities>>asset_ropa>>dpia_need_assessment>>modals>>cancel_request>>help',
            'Explain why the assessment is being cancelled.',
          ],
          confirm: ['processing_activities>>asset_ropa>>dpia_need_assessment>>modals>>cancel_request>>confirm', 'Cancel request'],
        },
      },
      validation: {
        trigger_comment: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>validation>>trigger_comment',
          'Describe why the DPIA need assessment was started.',
        ],
        always_rule_comment: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>validation>>always_rule_comment',
          'Describe the rule or policy that requires a DPIA.',
        ],
        decision_comment: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>validation>>decision_comment',
          'Enter a decision justification.',
        ],
        decision_required: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>validation>>decision_required',
          'Select a decision before confirming.',
        ],
        save_blocked: [
          'processing_activities>>asset_ropa>>dpia_need_assessment>>validation>>save_blocked',
          'Complete the required fields before saving.',
        ],
      },
      toasts: {
        saved: ['processing_activities>>asset_ropa>>dpia_need_assessment>>toasts>>saved', 'Assessment saved.'],
        decided: ['processing_activities>>asset_ropa>>dpia_need_assessment>>toasts>>decided', 'Decision recorded.'],
        cancelled: ['processing_activities>>asset_ropa>>dpia_need_assessment>>toasts>>cancelled', 'Assessment cancelled.'],
      },
      yes: ['processing_activities>>asset_ropa>>dpia_need_assessment>>yes', 'Yes'],
      no: ['processing_activities>>asset_ropa>>dpia_need_assessment>>no', 'No'],
      created_dpia: {
        title: ['processing_activities>>asset_ropa>>dpia_need_assessment>>created_dpia>>title', 'Created DPIA'],
        status: ['processing_activities>>asset_ropa>>dpia_need_assessment>>created_dpia>>status', 'Status'],
        responsible: ['processing_activities>>asset_ropa>>dpia_need_assessment>>created_dpia>>responsible', 'Responsible'],
        created_at: ['processing_activities>>asset_ropa>>dpia_need_assessment>>created_dpia>>created_at', 'Created'],
        open: ['processing_activities>>asset_ropa>>dpia_need_assessment>>created_dpia>>open', 'Open DPIA'],
      },
    },
    dpia_decisions: {
      proceed: {
        label: ['processing_activities>>asset_ropa>>dpia_decisions>>proceed>>label', 'Proceed'],
        tooltip: [
          'processing_activities>>asset_ropa>>dpia_decisions>>proceed>>tooltip',
          'The processing may start or continue with the safeguards already in place.',
        ],
      },
      proceed_with_required_safeguards: {
        label: [
          'processing_activities>>asset_ropa>>dpia_decisions>>proceed_with_required_safeguards>>label',
          'Proceed with required safeguards',
        ],
        tooltip: [
          'processing_activities>>asset_ropa>>dpia_decisions>>proceed_with_required_safeguards>>tooltip',
          'The processing may start, or the planned change may be implemented, only after the required safeguards have been implemented and verified.',
        ],
      },
      do_not_proceed: {
        label: ['processing_activities>>asset_ropa>>dpia_decisions>>do_not_proceed>>label', 'Do not proceed'],
        tooltip: [
          'processing_activities>>asset_ropa>>dpia_decisions>>do_not_proceed>>tooltip',
          'The proposed processing or change must not go ahead.',
        ],
      },
      prior_consultation_required: {
        label: ['processing_activities>>asset_ropa>>dpia_decisions>>prior_consultation_required>>label', 'Prior consultation required'],
        tooltip: [
          'processing_activities>>asset_ropa>>dpia_decisions>>prior_consultation_required>>tooltip',
          'The remaining risk is high and cannot be sufficiently reduced. The record stays open while consultation with the supervisory authority is handled. This decision does not authorize the processing to proceed.',
        ],
      },
    },
    dpia_history: {
      dialog_title: ['processing_activities>>asset_ropa>>dpia_history>>dialog_title', 'DPIA history'],
      current: ['processing_activities>>asset_ropa>>dpia_history>>current', 'Current'],
      untitled: ['processing_activities>>asset_ropa>>dpia_history>>untitled', 'DPIA'],
      empty: ['processing_activities>>asset_ropa>>dpia_history>>empty', 'No previous DPIAs are available for this processing activity.'],
    },
    owner_dpia: {
      page_title: ['processing_activities>>asset_ropa>>owner_dpia>>page_title', 'Data protection impact assessment'],
      page_subtitle: ['processing_activities>>asset_ropa>>owner_dpia>>page_subtitle', 'Complete the assessment and submit it for review.'],
      status: ['processing_activities>>asset_ropa>>owner_dpia>>status', 'Status'],
      responsible_owner: ['processing_activities>>asset_ropa>>owner_dpia>>responsible_owner', 'Responsible owner'],
      initiated: ['processing_activities>>asset_ropa>>owner_dpia>>initiated', 'Initiated'],
      source: ['processing_activities>>asset_ropa>>owner_dpia>>source', 'Source'],
      source_request: ['processing_activities>>asset_ropa>>owner_dpia>>source_request', 'DPIA need assessment'],
      open_source_request: ['processing_activities>>asset_ropa>>owner_dpia>>open_source_request', 'Open DPIA need assessment'],
      truth_note: [
        'processing_activities>>asset_ropa>>owner_dpia>>truth_note',
        'The DPIA documents risks and planned safeguards. Submitting the assessment does not mean that all measures have already been implemented or that all residual risk has been accepted.',
      ],
      close: ['processing_activities>>asset_ropa>>owner_dpia>>close', 'Close'],
      errors: {
        not_found: [
          'processing_activities>>asset_ropa>>owner_dpia>>errors>>not_found',
          'This DPIA is not available. It may have been removed, or you may not be the responsible owner.',
        ],
      },
      save_and_continue: ['processing_activities>>asset_ropa>>owner_dpia>>save_and_continue', 'Save and continue'],
      save_and_close: ['processing_activities>>asset_ropa>>owner_dpia>>save_and_close', 'Save and close'],
      submit: ['processing_activities>>asset_ropa>>owner_dpia>>submit', 'Submit for review'],
      start_reassessment: ['processing_activities>>asset_ropa>>owner_dpia>>start_reassessment', 'Start reassessment'],
      side_panel: {
        eyebrow: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>eyebrow', 'Read-only context'],
        title: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>title', 'Asset processing activity'],
        asset: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>asset', 'Asset'],
        processing_activity: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>processing_activity', 'Processing activity'],
        asset_type: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>asset_type', 'Asset type'],
        owner: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>owner', 'Operational owner'],
        data_subjects: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>data_subjects', 'Categories of data subjects'],
        personal_data: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>personal_data', 'Categories of personal data'],
        countries: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>countries', 'Country handling'],
        minimum_security: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>minimum_security', 'Minimum security assessment'],
        purpose_scope: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>purpose_scope', 'Purpose scope'],
        source_request: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>source_request', 'Initiating assessment'],
        recommendation: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>recommendation', 'System recommendation'],
        decision: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>decision', 'Decision'],
        trigger_source: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>trigger_source', 'Trigger source'],
        trigger_comment: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>trigger_comment', 'Trigger comment'],
        history: ['processing_activities>>asset_ropa>>owner_dpia>>side_panel>>history', 'DPIA history'],
      },
      sections: {
        scope: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>scope>>title', 'Scope and planned processing'],
          planned_processing: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>scope>>planned_processing',
            'Description of planned processing',
          ],
          assessment_scope: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>scope>>assessment_scope', 'Scope of the assessment'],
          project_context: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>scope>>project_context', 'Project or change context'],
          purposes: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>scope>>purposes', 'Purposes included in this DPIA'],
        },
        necessity: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>necessity>>title', 'Necessity and proportionality'],
          necessityAssessment: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>necessity>>necessity', 'Necessity assessment'],
          proportionalityAssessment: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>necessity>>proportionality',
            'Proportionality assessment',
          ],
          dataMinimisationAssessment: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>necessity>>data_minimisation',
            'Data minimisation assessment',
          ],
          retentionAndAccessAssessment: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>necessity>>retention_access',
            'Retention and access assessment',
          ],
        },
        risks: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>title', 'Risks to data subjects'],
          help: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>help',
            'Document risks to the rights and freedoms of data subjects, not only risks to the organisation.',
          ],
          add_risk: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>add_risk', '+ Add risk'],
          untitled: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>untitled', 'Untitled risk'],
          expand: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>expand', 'Expand'],
          collapse: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>collapse', 'Collapse'],
          risk_title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>risk_title', 'Risk title'],
          risk_description: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>risk_description', 'Risk description'],
          affected_rights: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>affected_rights',
            'Affected rights and freedoms',
          ],
          likelihood: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>likelihood', 'Likelihood'],
          impact: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>impact', 'Impact'],
          not_assessed: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>not_assessed', 'Not assessed'],
          measures: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>measures', 'Planned measures'],
          measure_title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>measure_title', 'Measure title'],
          measure_description: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>measure_description',
            'Measure description',
          ],
          measure_status: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>measure_status', 'Measure status'],
          measure_due_date: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>measure_due_date', 'Due date'],
          responsible: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>responsible', 'Responsible'],
          add_measure: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>risks>>add_measure', '+ Add measure'],
        },
        overall: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>overall>>title', 'Overall assessment and residual risk'],
          overall_assessment: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>overall>>overall_assessment',
            'Overall assessment',
          ],
          residual_risk: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>overall>>residual_risk',
            'Proposed residual risk level',
          ],
          prior_consultation: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>overall>>prior_consultation',
            'Prior consultation assessment',
          ],
          owner_conclusion: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>overall>>owner_conclusion', 'Owner conclusion'],
        },
        decision: {
          eyebrow: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>decision>>eyebrow', 'Review decision'],
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>decision>>title', 'Administrator decision'],
          review_comment: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>decision>>review_comment', 'Review comment'],
          decision_date: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>decision>>decision_date', 'Decision date'],
          decision_outcome: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>decision>>decision_outcome', 'Decision'],
        },
        clarification: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>clarification>>title', 'Administrator clarification'],
          response: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>clarification>>response', 'Response to clarification'],
        },
        completeness: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>completeness>>title', 'Completeness'],
        },
        submit: {
          title: ['processing_activities>>asset_ropa>>owner_dpia>>sections>>submit>>title', 'Submit DPIA for review'],
          help: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>submit>>help',
            'Submit when the assessment is complete. The ROPA administrator may approve it or request clarification.',
          ],
          notice: [
            'processing_activities>>asset_ropa>>owner_dpia>>sections>>submit>>notice',
            'Submitting the DPIA confirms that the assessment is complete enough for review. It does not mean that planned measures are implemented, residual risk is accepted or the processing has been approved.',
          ],
        },
      },
      statuses: {
        draft: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>draft', 'Draft'],
        in_progress: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>in_progress', 'In progress'],
        ready_for_review: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>ready_for_review', 'Ready for review'],
        clarification_requested: [
          'processing_activities>>asset_ropa>>owner_dpia>>statuses>>clarification_requested',
          'Clarification requested',
        ],
        decision_made: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>decision_made', 'Decision made'],
        cancelled: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>cancelled', 'Cancelled'],
        archived: ['processing_activities>>asset_ropa>>owner_dpia>>statuses>>archived', 'Archived'],
      },
      likelihood: {
        unlikely: ['processing_activities>>asset_ropa>>owner_dpia>>likelihood>>unlikely', 'Unlikely'],
        possible: ['processing_activities>>asset_ropa>>owner_dpia>>likelihood>>possible', 'Possible'],
        likely: ['processing_activities>>asset_ropa>>owner_dpia>>likelihood>>likely', 'Likely'],
        very_likely: ['processing_activities>>asset_ropa>>owner_dpia>>likelihood>>very_likely', 'Very likely'],
      },
      impact: {
        limited: ['processing_activities>>asset_ropa>>owner_dpia>>impact>>limited', 'Limited'],
        significant: ['processing_activities>>asset_ropa>>owner_dpia>>impact>>significant', 'Significant'],
        serious: ['processing_activities>>asset_ropa>>owner_dpia>>impact>>serious', 'Serious'],
        very_serious: ['processing_activities>>asset_ropa>>owner_dpia>>impact>>very_serious', 'Very serious'],
      },
      measure_status: {
        planned: ['processing_activities>>asset_ropa>>owner_dpia>>measure_status>>planned', 'Planned'],
        in_progress: ['processing_activities>>asset_ropa>>owner_dpia>>measure_status>>in_progress', 'In progress'],
        completed: ['processing_activities>>asset_ropa>>owner_dpia>>measure_status>>completed', 'Completed'],
        not_applicable: ['processing_activities>>asset_ropa>>owner_dpia>>measure_status>>not_applicable', 'Not applicable'],
      },
      residual_risk: {
        not_assessed: ['processing_activities>>asset_ropa>>owner_dpia>>residual_risk>>not_assessed', 'Not assessed'],
        low: ['processing_activities>>asset_ropa>>owner_dpia>>residual_risk>>low', 'Low'],
        medium: ['processing_activities>>asset_ropa>>owner_dpia>>residual_risk>>medium', 'Medium'],
        high: ['processing_activities>>asset_ropa>>owner_dpia>>residual_risk>>high', 'High'],
        very_high: ['processing_activities>>asset_ropa>>owner_dpia>>residual_risk>>very_high', 'Very high'],
      },
      prior_consultation: {
        not_assessed: ['processing_activities>>asset_ropa>>owner_dpia>>prior_consultation>>not_assessed', 'Not assessed'],
        not_required: ['processing_activities>>asset_ropa>>owner_dpia>>prior_consultation>>not_required', 'Not required'],
        may_be_required: ['processing_activities>>asset_ropa>>owner_dpia>>prior_consultation>>may_be_required', 'May be required'],
        required: ['processing_activities>>asset_ropa>>owner_dpia>>prior_consultation>>required', 'Required'],
      },
      completeness: {
        planned_processing: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>planned_processing',
          'Planned processing is described',
        ],
        necessity_proportionality: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>necessity_proportionality',
          'Necessity and proportionality are assessed',
        ],
        at_least_one_risk: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>at_least_one_risk',
          'At least one risk is documented',
        ],
        risk_measures: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>risk_measures',
          'Every risk has at least one planned measure',
        ],
        measure_responsible: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>measure_responsible',
          'Every planned measure has a responsible person',
        ],
        residual_risk: ['processing_activities>>asset_ropa>>owner_dpia>>completeness>>residual_risk', 'Residual risk is assessed'],
        prior_consultation: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>prior_consultation',
          'Prior consultation assessment is complete',
        ],
        clarification_response: [
          'processing_activities>>asset_ropa>>owner_dpia>>completeness>>clarification_response',
          'Clarification response is provided',
        ],
      },
      validation: {
        purpose_scope: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>purpose_scope', 'Select at least one purpose.'],
        risk_title: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_title', 'Enter a risk title.'],
        risk_description: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_description', 'Enter a risk description.'],
        risk_affected_rights: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_affected_rights',
          'Describe affected rights and freedoms.',
        ],
        risk_likelihood: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_likelihood', 'Select likelihood.'],
        risk_impact: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_impact', 'Select impact.'],
        risk_measures: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>risk_measures', 'Add at least one measure per risk.'],
        measure_title: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>measure_title', 'Enter a measure title.'],
        measure_description: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>measure_description',
          'Enter a measure description.',
        ],
        measure_responsible: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>measure_responsible',
          'Assign a responsible person.',
        ],
        measure_status: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>measure_status', 'Select measure status.'],
        clarification_response: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>clarification_response',
          'Provide a response to the clarification request.',
        ],
        residual_risk: ['processing_activities>>asset_ropa>>owner_dpia>>validation>>residual_risk', 'Assess residual risk.'],
        prior_consultation: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>prior_consultation',
          'Complete the prior consultation assessment.',
        ],
        submit_blocked: [
          'processing_activities>>asset_ropa>>owner_dpia>>validation>>submit_blocked',
          'Complete the required fields before submitting for review.',
        ],
      },
      toasts: {
        saved: ['processing_activities>>asset_ropa>>owner_dpia>>toasts>>saved', 'DPIA saved.'],
        submitted: ['processing_activities>>asset_ropa>>owner_dpia>>toasts>>submitted', 'DPIA submitted for review.'],
        conflict: [
          'processing_activities>>asset_ropa>>owner_dpia>>toasts>>conflict',
          'This DPIA was changed elsewhere. Reloaded the latest version — review your changes and try again.',
        ],
        reassessed: ['processing_activities>>asset_ropa>>owner_dpia>>toasts>>reassessed', 'DPIA reassessment started.'],
        reassess_failed: [
          'processing_activities>>asset_ropa>>owner_dpia>>toasts>>reassess_failed',
          'Could not start the DPIA reassessment.',
        ],
      },
    },
    admin_dpia_review: {
      page_title: ['processing_activities>>asset_ropa>>admin_dpia_review>>page_title', 'Review data protection impact assessment'],
      page_subtitle: [
        'processing_activities>>asset_ropa>>admin_dpia_review>>page_subtitle',
        'ROPA administrator review · Data protection impact assessment',
      ],
      close: ['processing_activities>>asset_ropa>>admin_dpia_review>>close', 'Close'],
      errors: {
        not_found: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>errors>>not_found',
          'This DPIA review is not available. It may have been removed, or you may not have access.',
        ],
      },
      status: ['processing_activities>>asset_ropa>>admin_dpia_review>>status', 'Status'],
      responsible_owner: ['processing_activities>>asset_ropa>>admin_dpia_review>>responsible_owner', 'Responsible owner'],
      submitted: ['processing_activities>>asset_ropa>>admin_dpia_review>>submitted', 'Submitted'],
      submitted_revision: ['processing_activities>>asset_ropa>>admin_dpia_review>>submitted_revision', 'Submitted revision'],
      current_revision: ['processing_activities>>asset_ropa>>admin_dpia_review>>current_revision', 'Current revision'],
      truth_note: [
        'processing_activities>>asset_ropa>>admin_dpia_review>>truth_note',
        'Approval confirms that the DPIA is sufficiently documented as an assessment. It does not approve the processing itself, confirm that measures are completed or accept residual risk on behalf of management.',
      ],
      approval_notice: [
        'processing_activities>>asset_ropa>>admin_dpia_review>>approval_notice',
        'Approval means that the DPIA is sufficiently documented as an assessment. It does not approve the processing itself, confirm that measures are completed or accept residual risk on behalf of management.',
      ],
      changed_after_submission_badge: [
        'processing_activities>>asset_ropa>>admin_dpia_review>>changed_after_submission_badge',
        'Changed after submission',
      ],
      integrity_banner: {
        title: ['processing_activities>>asset_ropa>>admin_dpia_review>>integrity_banner>>title', 'Submission integrity:'],
        body: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>integrity_banner>>body',
          'The current DPIA revision must match the submitted revision before approval. If the DPIA changes after submission, the asset owner must submit the current revision again.',
        ],
      },
      sections: {
        clarification_history: {
          eyebrow: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>clarification_history>>eyebrow', 'Review history'],
          title: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>clarification_history>>title',
            'Latest clarification and owner response',
          ],
          requested_at: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>clarification_history>>requested_at',
            'Clarification requested on {{date}} by {{name}}',
          ],
          owner_response: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>clarification_history>>owner_response',
            'Owner response',
          ],
        },
        summary: {
          eyebrow: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>eyebrow', 'Review support'],
          title: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>title', 'Review summary'],
          help: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>help',
            'This summary supports the decision but does not replace reviewing the DPIA content.',
          ],
          documented_risks: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>documented_risks',
            'Documented risks',
          ],
          high_risks: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>high_risks', 'High or very high risks'],
          open_measures: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>open_measures',
            'Planned or ongoing measures',
          ],
          residual_risk: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>summary>>residual_risk', 'Residual risk'],
        },
        decision: {
          eyebrow: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>eyebrow', 'Administrator decision'],
          title: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>title', 'Review decision'],
          help: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>help',
            'Choose one decision outcome and provide a mandatory comment before submitting.',
          ],
          review_comment: ['processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>review_comment', 'Decision comment'],
          review_comment_help: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>review_comment_help',
            'Required for every decision.',
          ],
          decision_made_notice: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>decision_made_notice',
            'Decision made on {{date}} by {{name}}.',
          ],
          clarification_title: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>clarification_title',
            'Request for clarification',
          ],
          awaiting_resubmission: [
            'processing_activities>>asset_ropa>>admin_dpia_review>>sections>>decision>>awaiting_resubmission',
            'The asset owner must resubmit the DPIA before a new review decision can be recorded.',
          ],
        },
      },
      warnings: {
        high_residual_risk: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>warnings>>high_residual_risk',
          'The DPIA records high or very high residual risk. Approval confirms that the assessment is sufficiently documented, not that the residual risk has been accepted.',
        ],
        prior_consultation_may_be_required: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>warnings>>prior_consultation_may_be_required',
          'Prior consultation may be required.',
        ],
        prior_consultation_required: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>warnings>>prior_consultation_required',
          'Prior consultation required.',
        ],
        open_measures: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>warnings>>open_measures',
          'Measures remain planned or in progress. This does not block approval of a complete and truthful assessment.',
        ],
        third_country_processing: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>warnings>>third_country_processing',
          'Third-country processing is documented.',
        ],
      },
      actions: {
        submit_decision: ['processing_activities>>asset_ropa>>admin_dpia_review>>actions>>submit_decision', 'Submit decision'],
        request_clarification: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>actions>>request_clarification',
          'Request for clarification',
        ],
      },
      validation: {
        changed_after_submission: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>validation>>changed_after_submission',
          'The DPIA changed after submission. The asset owner must submit the current revision before it can be approved.',
        ],
        incomplete_approval: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>validation>>incomplete_approval',
          'The DPIA cannot be approved because required information is incomplete.',
        ],
        clarification_comment: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>validation>>clarification_comment',
          'Enter a clarification comment.',
        ],
        review_comment_required: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>validation>>review_comment_required',
          'Enter a decision comment.',
        ],
        decision_choice_required: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>validation>>decision_choice_required',
          'Choose a decision before submitting.',
        ],
      },
      toasts: {
        decision_submitted: ['processing_activities>>asset_ropa>>admin_dpia_review>>toasts>>decision_submitted', 'Decision submitted.'],
        clarification_requested: [
          'processing_activities>>asset_ropa>>admin_dpia_review>>toasts>>clarification_requested',
          'Clarification requested.',
        ],
      },
    },
    apa_editor: {
      page_title: ['processing_activities>>asset_ropa>>apa_editor>>page_title', 'Asset processing activity'],
      page_subtitle: [
        'processing_activities>>asset_ropa>>apa_editor>>page_subtitle',
        'Compare the central processing activity with your asset-specific implementation.',
      ],
      clarification_comment: ['processing_activities>>asset_ropa>>apa_editor>>clarification_comment', 'Clarification comment'],
      clarification_response: ['processing_activities>>asset_ropa>>apa_editor>>clarification_response', 'Owner response'],
      clarify: ['processing_activities>>asset_ropa>>apa_editor>>clarify', 'Clarify'],
      truth_note: [
        'processing_activities>>asset_ropa>>apa_editor>>truth_note',
        'You are responsible for ensuring that the information is accurate and complete before submission.',
      ],
      security_comment: ['processing_activities>>asset_ropa>>apa_editor>>security_comment', 'Security comment'],
      minimum_security_assessment: [
        'processing_activities>>asset_ropa>>apa_editor>>minimum_security_assessment',
        'Minimum security assessment',
      ],
      dpia_indication: ['processing_activities>>asset_ropa>>apa_editor>>dpia_indication', 'DPIA indication'],
      dpia_comment: ['processing_activities>>asset_ropa>>apa_editor>>dpia_comment', 'DPIA indication comment'],
      save: ['processing_activities>>asset_ropa>>apa_editor>>save', 'Save and continue'],
      save_close: ['processing_activities>>asset_ropa>>apa_editor>>save_close', 'Save and close'],
      submit: ['processing_activities>>asset_ropa>>apa_editor>>submit', 'Submit for review'],
      submit_clarification_response: [
        'processing_activities>>asset_ropa>>apa_editor>>submit_clarification_response',
        'Submit clarification response',
      ],
      edit: ['processing_activities>>asset_ropa>>apa_editor>>edit', 'Edit'],
      close: ['processing_activities>>asset_ropa>>apa_editor>>close', 'Close'],
      errors: {
        not_found: [
          'processing_activities>>asset_ropa>>apa_editor>>errors>>not_found',
          'This asset processing activity is not available. It may have been removed, or you may not be the owner of this asset.',
        ],
      },
      validation: {
        required: ['processing_activities>>asset_ropa>>apa_editor>>validation>>required', 'Required field'],
        purpose_not_assessed: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>purpose_not_assessed',
          'Every purpose must have an applicability status.',
        ],
        purpose_applies_incomplete: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>purpose_applies_incomplete',
          'Complete all required fields for purposes that apply.',
        ],
        purpose_does_not_apply_justification: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>purpose_does_not_apply_justification',
          'Explain why this purpose does not apply to the asset.',
        ],
        security_incomplete: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>security_incomplete',
          'Select security measures or describe them in the security comment.',
        ],
        security_comment_required: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>security_comment_required',
          'A security assessment comment is required for this assessment result.',
        ],
        country_row_invalid: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>country_row_invalid',
          'Each country row needs at least one handling type and a volume.',
        ],
        countries_required: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>countries_required',
          'Add at least one country handling row before submitting.',
        ],
        dpia_comment_required: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>dpia_comment_required',
          'A DPIA indication comment is required when DPIA is indicated.',
        ],
        submit_blocked: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>submit_blocked',
          'Complete the required fields before submitting for review.',
        ],
        clarification_response: [
          'processing_activities>>asset_ropa>>apa_editor>>validation>>clarification_response',
          'Enter a response to the clarification request before submitting.',
        ],
      },
      sections: {
        security: {
          title: ['processing_activities>>asset_ropa>>apa_editor>>sections>>security>>title', 'Security measures'],
          categories: ['processing_activities>>asset_ropa>>apa_editor>>sections>>security>>categories', 'Security measure categories'],
          comment: ['processing_activities>>asset_ropa>>apa_editor>>sections>>security>>comment', 'Security measures description'],
          minimum_assessment: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment',
            'Minimum security requirements',
          ],
          minimum_assessment_comment: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment_comment',
            'Security assessment comment',
          ],
          category_options: {
            access_control: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>access_control',
              'Access control',
            ],
            encryption_in_transit: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>encryption_in_transit',
              'Encryption in transit',
            ],
            encryption_at_rest: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>encryption_at_rest',
              'Encryption at rest',
            ],
            logging_monitoring: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>logging_monitoring',
              'Logging and monitoring',
            ],
            backup_recovery: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>backup_recovery',
              'Backup and recovery',
            ],
            incident_response: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>category_options>>incident_response',
              'Incident response',
            ],
          },
          minimum_assessment_options: {
            not_assessed: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment_options>>not_assessed',
              'Not assessed',
            ],
            meets: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment_options>>meets',
              'Meets requirements',
            ],
            partially_meets: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment_options>>partially_meets',
              'Partially meets requirements',
            ],
            does_not_meet: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>security>>minimum_assessment_options>>does_not_meet',
              'Does not meet requirements',
            ],
          },
        },
        purposes: {
          title: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>title', 'Purpose applications'],
          central_definition: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>central_definition',
            'Organization definition',
          ],
          asset_application: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>asset_application', 'Asset application'],
          applicability: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>applicability', 'Applicability'],
          legal_basis: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>legal_basis', 'Legal basis'],
          retention_rule: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_rule', 'Central retention rule'],
          application_description: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>application_description',
            'Application in this asset',
          ],
          justification: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>justification', 'Justification'],
          retention_trigger: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_trigger',
            'Retention start trigger',
          ],
          retention_value: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_value', 'Retention value'],
          retention_unit: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_unit', 'Retention unit'],
          retention_period_and_unit: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_period_and_unit',
            'Period and unit',
          ],
          retention_comment: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>retention_comment', 'Comment'],
          deletion_routine: [
            'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>deletion_routine',
            'Deletion and anonymisation routines',
          ],
          applicability_options: {
            not_assessed: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>applicability_options>>not_assessed',
              'Not assessed',
            ],
            applies: ['processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>applicability_options>>applies', 'Applies'],
            does_not_apply: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>purposes>>applicability_options>>does_not_apply',
              'Does not apply',
            ],
          },
        },
        countries: {
          title: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>title', 'Country processing'],
          country_name: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>country_name', 'Country'],
          volume: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume', 'Volume'],
          handling_types: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>handling_types', 'Handling'],
          add_row: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>add_row', 'Add country row'],
          remove_row: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>remove_row', 'Remove country row'],
          handling: {
            storage: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>handling>>storage', 'Storage'],
            access: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>handling>>access', 'Access'],
            support: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>handling>>support', 'Support'],
            development: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>handling>>development', 'Development'],
          },
          volume_options: {
            very_low: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume_options>>very_low', 'Very low'],
            low: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume_options>>low', 'Low'],
            medium: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume_options>>medium', 'Medium'],
            high: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume_options>>high', 'High'],
            very_high: ['processing_activities>>asset_ropa>>apa_editor>>sections>>countries>>volume_options>>very_high', 'Very high'],
          },
        },
        dpia: {
          title: ['processing_activities>>asset_ropa>>apa_editor>>sections>>dpia>>title', 'DPIA indication'],
          status: ['processing_activities>>asset_ropa>>apa_editor>>sections>>dpia>>status', 'DPIA indication'],
          comment: ['processing_activities>>asset_ropa>>apa_editor>>sections>>dpia>>comment', 'DPIA indication comment'],
          status_options: {
            not_indicated: [
              'processing_activities>>asset_ropa>>apa_editor>>sections>>dpia>>status_options>>not_indicated',
              'Not indicated',
            ],
            indicated: ['processing_activities>>asset_ropa>>apa_editor>>sections>>dpia>>status_options>>indicated', 'Indicated'],
          },
        },
      },
      toasts: {
        saved: ['processing_activities>>asset_ropa>>apa_editor>>toasts>>saved', 'Changes saved.'],
        submitted: ['processing_activities>>asset_ropa>>apa_editor>>toasts>>submitted', 'Submitted for review.'],
        conflict: [
          'processing_activities>>asset_ropa>>apa_editor>>toasts>>conflict',
          'The data was changed in the meantime. The form has been refreshed.',
        ],
        revision_missing: [
          'processing_activities>>asset_ropa>>apa_editor>>toasts>>revision_missing',
          'Could not save because the request was missing a required revision. Please try again or contact support.',
        ],
        inactive_review_round: [
          'processing_activities>>asset_ropa>>apa_editor>>toasts>>inactive_review_round',
          'This review is no longer active, so the submission cannot be completed.',
        ],
      },
    },
  },
  asset_reviews: {
    page_title: ['processing_activities>>asset_reviews>>page_title', 'Processing activity asset reviews'],
    page_subtitle: [
      'processing_activities>>asset_reviews>>page_subtitle',
      'Review and validate how data is actually processed after a review has been initiated from the processing activities register.',
    ],
    campaign_label: ['processing_activities>>asset_reviews>>campaign_label', 'Campaign: {{name}}'],
    empty_state: ['processing_activities>>asset_reviews>>empty_state', 'No assets match the current filters.'],
    actions: {
      back: ['processing_activities>>asset_reviews>>actions>>back', 'Back'],
      add_assets: ['processing_activities>>asset_reviews>>actions>>add_assets', 'Add assets'],
      add_purpose: ['processing_activities>>asset_reviews>>actions>>add_purpose', '+ Add purpose'],
      submit_review: ['processing_activities>>asset_reviews>>actions>>submit_review', 'Submit review'],
    },
    metrics: {
      total_assets: ['processing_activities>>asset_reviews>>metrics>>total_assets', 'Total assets'],
      completed: ['processing_activities>>asset_reviews>>metrics>>completed', 'Completed'],
      in_progress: ['processing_activities>>asset_reviews>>metrics>>in_progress', 'In progress'],
      not_started: ['processing_activities>>asset_reviews>>metrics>>not_started', 'Not started'],
      overdue: ['processing_activities>>asset_reviews>>metrics>>overdue', 'Overdue'],
    },
    filters: {
      search_placeholder: ['processing_activities>>asset_reviews>>filters>>search_placeholder', 'Search asset or purpose'],
      status_all: ['processing_activities>>asset_reviews>>filters>>status_all', 'Status: All'],
      flag_all: ['processing_activities>>asset_reviews>>filters>>flag_all', 'Flag filter: All'],
    },
    status_options: {
      not_started: ['processing_activities>>asset_reviews>>status_options>>not_started', 'Not started'],
      in_progress: ['processing_activities>>asset_reviews>>status_options>>in_progress', 'In progress'],
      submitted: ['processing_activities>>asset_reviews>>status_options>>submitted', 'Submitted'],
      approved: ['processing_activities>>asset_reviews>>status_options>>approved', 'Approved'],
      overdue: ['processing_activities>>asset_reviews>>status_options>>overdue', 'Overdue'],
    },
    flag_options: {
      critical_flags: ['processing_activities>>asset_reviews>>flag_options>>critical_flags', 'Critical flags'],
      retention_issues: ['processing_activities>>asset_reviews>>flag_options>>retention_issues', 'Retention issues'],
      security_issues: ['processing_activities>>asset_reviews>>flag_options>>security_issues', 'Security issues'],
      third_country_issues: ['processing_activities>>asset_reviews>>flag_options>>third_country_issues', 'Third-country issues'],
      dpia_related: ['processing_activities>>asset_reviews>>flag_options>>dpia_related', 'DPIA-related'],
    },
    table: {
      aria_label: ['processing_activities>>asset_reviews>>table>>aria_label', 'Asset reviews table'],
      asset: ['processing_activities>>asset_reviews>>table>>asset', 'Asset'],
      owner: ['processing_activities>>asset_reviews>>table>>owner', 'Owner'],
      status: ['processing_activities>>asset_reviews>>table>>status', 'Status'],
      reviewed: ['processing_activities>>asset_reviews>>table>>reviewed', 'Reviewed'],
      due_date: ['processing_activities>>asset_reviews>>table>>due_date', 'Due date'],
      flags: ['processing_activities>>asset_reviews>>table>>flags', 'Flags'],
      last_activity: ['processing_activities>>asset_reviews>>table>>last_activity', 'Last activity'],
    },
    collapse: {
      owner: ['processing_activities>>asset_reviews>>collapse>>owner', 'Owner: {{name}}'],
      status: ['processing_activities>>asset_reviews>>collapse>>status', 'Status: {{status}}'],
      reviewed: ['processing_activities>>asset_reviews>>collapse>>reviewed', 'Reviewed: {{answered}} / {{included}}'],
      flags: ['processing_activities>>asset_reviews>>collapse>>flags', 'Flags: {{count}}'],
      asset_type: ['processing_activities>>asset_reviews>>collapse>>asset_type', 'Asset type'],
      confidentiality: ['processing_activities>>asset_reviews>>collapse>>confidentiality', 'Confidentiality'],
      contains_personal_data: ['processing_activities>>asset_reviews>>collapse>>contains_personal_data', 'Contains personal data'],
      review_state: ['processing_activities>>asset_reviews>>collapse>>review_state', 'Review state: {{state}}'],
      retention: ['processing_activities>>asset_reviews>>collapse>>retention', 'Retention'],
      countries: ['processing_activities>>asset_reviews>>collapse>>countries', 'Countries'],
      security: ['processing_activities>>asset_reviews>>collapse>>security', 'Security'],
      volume: ['processing_activities>>asset_reviews>>collapse>>volume', 'Volume'],
      dpia: ['processing_activities>>asset_reviews>>collapse>>dpia', 'DPIA'],
    },
  },
};

export default processing_activities_messages;
